// Imports
var ___CSS_LOADER_API_SOURCEMAP_IMPORT___ = require("../../../../node_modules/css-loader/dist/runtime/sourceMaps.js");
var ___CSS_LOADER_API_IMPORT___ = require("../../../../node_modules/css-loader/dist/runtime/api.js");
var ___CSS_LOADER_EXPORT___ = ___CSS_LOADER_API_IMPORT___(___CSS_LOADER_API_SOURCEMAP_IMPORT___);
// Module
___CSS_LOADER_EXPORT___.push([module.id, `@charset "UTF-8";
.pricing-page {
  min-height: 100vh;
  background-color: #f8fafc;
  padding-bottom: 3rem;
}

/* Dark mode */
:host-context(body.theme-dark) {
  /* Catch any remaining copy that may inherit light-mode colors */
  /* AI Coins section – dark mode */
}
:host-context(body.theme-dark) .pricing-page {
  background: #0a0c10 !important;
  color: #e5e7eb !important;
}
:host-context(body.theme-dark) .pricing-header .pricing-title,
:host-context(body.theme-dark) .section-title,
:host-context(body.theme-dark) .plan-name,
:host-context(body.theme-dark) .plan-label,
:host-context(body.theme-dark) .price-amount,
:host-context(body.theme-dark) .price-text {
  color: #f8fafc !important;
}
:host-context(body.theme-dark) .pricing-header .pricing-subtitle,
:host-context(body.theme-dark) .section-subtitle,
:host-context(body.theme-dark) .plan-description,
:host-context(body.theme-dark) .price-period,
:host-context(body.theme-dark) .billing-note,
:host-context(body.theme-dark) .feature-item span {
  color: #cbd5e1 !important;
}
:host-context(body.theme-dark) .billing-label {
  color: #94a3b8 !important;
}
:host-context(body.theme-dark) .billing-label.active {
  color: #f8fafc !important;
}
:host-context(body.theme-dark) .billing-toggle {
  background-color: #334155 !important;
}
:host-context(body.theme-dark) .billing-toggle-container .discount-badge {
  background-color: #166534 !important;
  color: #dcfce7 !important;
  border: 1px solid rgba(134, 239, 172, 0.35);
}
:host-context(body.theme-dark) .plan-card,
:host-context(body.theme-dark) .business-plan-card,
:host-context(body.theme-dark) .add-on-card,
:host-context(body.theme-dark) .comparison-table,
:host-context(body.theme-dark) .faq-item,
:host-context(body.theme-dark) .free-tier-card {
  background: #111827 !important;
  border-color: rgba(148, 163, 184, 0.25) !important;
  box-shadow: none !important;
}
:host-context(body.theme-dark) .free-tier-icon {
  background: rgba(94, 161, 216, 0.18) !important;
  color: #93c5fd !important;
}
:host-context(body.theme-dark) .free-tier-titles .plan-tier-tag {
  color: #6ee7b7 !important;
  background: rgba(6, 95, 70, 0.45) !important;
}
@media (min-width: 900px) {
  :host-context(body.theme-dark) .free-tier-col--cta,
  :host-context(body.theme-dark) .free-tier-col--features {
    border-left-color: rgba(148, 163, 184, 0.25) !important;
  }
}
:host-context(body.theme-dark) .free-tier-section .section-kicker {
  color: #93c5fd !important;
}
:host-context(body.theme-dark) .plan-card.featured {
  border-color: #5ea1d8 !important;
}
:host-context(body.theme-dark) .plan-button.outline,
:host-context(body.theme-dark) .cta-button.secondary {
  background: transparent !important;
  border-color: #5ea1d8 !important;
  color: #93c5fd !important;
}
:host-context(body.theme-dark) .plan-button.outline:hover,
:host-context(body.theme-dark) .cta-button.secondary:hover {
  background: rgba(94, 161, 216, 0.16) !important;
}
:host-context(body.theme-dark) .pricing-page p,
:host-context(body.theme-dark) .pricing-page li,
:host-context(body.theme-dark) .pricing-page td,
:host-context(body.theme-dark) .pricing-page th,
:host-context(body.theme-dark) .pricing-page label {
  color: #cbd5e1 !important;
}
:host-context(body.theme-dark) .pricing-page span:not(.material-icons) {
  color: #cbd5e1 !important;
}
:host-context(body.theme-dark) .add-ons-section .section-title,
:host-context(body.theme-dark) .add-ons-section .add-on-title,
:host-context(body.theme-dark) .add-ons-section .price-text {
  color: #f8fafc !important;
}
:host-context(body.theme-dark) .add-ons-section .add-on-description,
:host-context(body.theme-dark) .add-ons-section .price-unit {
  color: #cbd5e1 !important;
}
:host-context(body.theme-dark) .add-ons-section .add-on-price {
  border-top-color: rgba(148, 163, 184, 0.25) !important;
}
:host-context(body.theme-dark) .ai-coins-section,
:host-context(body.theme-dark) .guide-topups-section {
  background: linear-gradient(180deg, rgba(232, 62, 140, 0.1) 0%, rgba(17, 24, 39, 0.55) 100%) !important;
  border-color: rgba(232, 62, 140, 0.22) !important;
}
:host-context(body.theme-dark) .ai-coins-section .section-title,
:host-context(body.theme-dark) .ai-coins-section .coin-pack-name,
:host-context(body.theme-dark) .ai-coins-section .coin-pack-price .price-amount,
:host-context(body.theme-dark) .ai-coins-section .balance-value {
  color: #f8fafc !important;
}
:host-context(body.theme-dark) .ai-coins-section .section-subtitle,
:host-context(body.theme-dark) .ai-coins-section .coin-pack-description,
:host-context(body.theme-dark) .ai-coins-section .coin-pack-price .price-unit,
:host-context(body.theme-dark) .ai-coins-section .balance-label,
:host-context(body.theme-dark) .ai-coins-section .balance-detail,
:host-context(body.theme-dark) .ai-coins-section .coin-footnote {
  color: #94a3b8 !important;
}
:host-context(body.theme-dark) .ai-coins-section .section-icon,
:host-context(body.theme-dark) .ai-coins-section .coin-pack-amount,
:host-context(body.theme-dark) .ai-coins-section .inline-link {
  color: #f472b6 !important;
}
:host-context(body.theme-dark) .coin-balance-banner {
  background: linear-gradient(135deg, rgba(94, 161, 216, 0.16), rgba(232, 62, 140, 0.12)) !important;
  border-color: rgba(148, 163, 184, 0.28) !important;
}
:host-context(body.theme-dark) .coin-pack-card {
  background: #111827 !important;
  border-color: rgba(148, 163, 184, 0.28) !important;
  box-shadow: none !important;
}
:host-context(body.theme-dark) .coin-pack-card:hover {
  border-color: rgba(232, 62, 140, 0.45) !important;
  box-shadow: 0 8px 24px rgba(0, 0, 0, 0.35) !important;
}
:host-context(body.theme-dark) .coin-pack-card.featured {
  border-color: #e83e8c !important;
  background: linear-gradient(180deg, rgba(232, 62, 140, 0.12) 0%, #111827 40%) !important;
}
:host-context(body.theme-dark) .coin-pack-icon {
  background: rgba(232, 62, 140, 0.18) !important;
  color: #f472b6 !important;
}
:host-context(body.theme-dark) .coin-pack-badge {
  background: #e83e8c !important;
  color: #ffffff !important;
}
:host-context(body.theme-dark) .plan-tier-tag {
  background: #1f2937 !important;
  color: #cbd5e1 !important;
}
:host-context(body.theme-dark) .plan-tier-tag.creator {
  background: rgba(94, 161, 216, 0.2) !important;
  color: #93c5fd !important;
}
:host-context(body.theme-dark) .plan-icon,
:host-context(body.theme-dark) .feature-item .material-icons,
:host-context(body.theme-dark) .feature-item .check-icon {
  color: #93c5fd !important;
}
:host-context(body.theme-dark) .feature-item.disabled,
:host-context(body.theme-dark) .feature-item.disabled .material-icons {
  color: #64748b !important;
}
:host-context(body.theme-dark) .audience-label,
:host-context(body.theme-dark) .audience-text,
:host-context(body.theme-dark) .plan-audience p {
  color: #94a3b8 !important;
}
:host-context(body.theme-dark) .price-old {
  color: #64748b !important;
}
:host-context(body.theme-dark) .price-new {
  color: #f8fafc !important;
}
:host-context(body.theme-dark) .faq-question,
:host-context(body.theme-dark) .faq-item h3,
:host-context(body.theme-dark) .faq-item .question,
:host-context(body.theme-dark) .comparison-table th,
:host-context(body.theme-dark) .comparison-table td {
  color: #e2e8f0 !important;
}
:host-context(body.theme-dark) .cta-section,
:host-context(body.theme-dark) .cta-card {
  background: #111827 !important;
  color: #e2e8f0 !important;
}
:host-context(body.theme-dark) .plan-button.current-plan,
:host-context(body.theme-dark) .plan-button.dark {
  background: #1f2937 !important;
  color: #e2e8f0 !important;
  border-color: rgba(148, 163, 184, 0.35) !important;
}

.footer {
  background: #f1f5f9;
  color: #475569;
  padding: 14px 0;
  border-top: 1px solid #e2e8f0;
}
.footer .copy-rights {
  max-width: 1400px;
  margin: 0 auto;
  padding: 0 24px;
  width: 100%;
}
.footer .copy-rights .row {
  display: flex;
  align-items: center;
  margin: 0;
  width: 100%;
}
@media (max-width: 768px) {
  .footer .copy-rights .row {
    flex-direction: column;
    align-items: flex-start;
    gap: 16px;
  }
}
.footer .copy-rights .col-md-5,
.footer .copy-rights .col-md-7,
.footer .copy-rights .col-12 {
  padding: 0;
  display: flex;
  align-items: center;
}
@media (max-width: 768px) {
  .footer .copy-rights .col-md-5,
  .footer .copy-rights .col-md-7,
  .footer .copy-rights .col-12 {
    width: 100%;
    justify-content: flex-start;
  }
}
@media (min-width: 769px) {
  .footer .copy-rights .col-md-5 {
    justify-content: flex-start;
  }
}
@media (min-width: 769px) {
  .footer .copy-rights .col-md-7 {
    justify-content: flex-end;
  }
}
.footer .cpyrgt {
  color: #64748b !important;
  list-style: none;
  padding: 0;
  margin: 0;
  display: flex;
  align-items: center;
  font-size: 14px;
  line-height: 1.5;
  width: 100%;
}
@media (max-width: 768px) {
  .footer .cpyrgt {
    flex-wrap: wrap;
  }
}
.footer .cpyrgt li {
  color: #64748b !important;
  margin: 0;
  padding: 0;
  display: flex;
  align-items: center;
  flex-wrap: wrap;
}
.footer .cpyrgt li a {
  color: #64748b !important;
  text-decoration: none;
  margin-left: 4px;
}
.footer .cpyrgt li a:hover {
  color: #5ea1d8 !important;
  text-decoration: underline;
}
.footer .f-menu-right {
  display: flex;
  list-style: none;
  padding: 0;
  margin: 0;
  align-items: center;
  justify-content: flex-end;
  flex-wrap: wrap;
  gap: 0;
  width: 100%;
}
@media (max-width: 768px) {
  .footer .f-menu-right {
    justify-content: flex-start;
    flex-direction: column;
    align-items: flex-start;
    gap: 8px;
  }
}
.footer .f-menu-right li {
  margin: 0;
  padding: 0;
}
@media (min-width: 769px) {
  .footer .f-menu-right li:not(:last-child)::after {
    content: "|";
    margin: 0 12px;
    color: #94a3b8;
  }
}
.footer .f-menu-right li a {
  color: #64748b !important;
  text-decoration: none;
  font-size: 14px;
  transition: color 0.2s ease;
}
.footer .f-menu-right li a:hover {
  color: #5ea1d8 !important;
  text-decoration: underline;
}

:host-context(body.theme-dark) .footer {
  background: #000000 !important;
  color: #ffffff !important;
  border-top: 1px solid rgba(255, 255, 255, 0.05) !important;
}
:host-context(body.theme-dark) .footer .cpyrgt,
:host-context(body.theme-dark) .footer .cpyrgt li,
:host-context(body.theme-dark) .footer .cpyrgt li a,
:host-context(body.theme-dark) .footer .f-menu-right li a {
  color: #64748b !important;
}
:host-context(body.theme-dark) .footer .cpyrgt li a:hover,
:host-context(body.theme-dark) .footer .f-menu-right li a:hover {
  color: #5ea1d8 !important;
}
:host-context(body.theme-dark) .footer .f-menu-right li:not(:last-child)::after {
  color: #64748b;
}

.pricing-header {
  text-align: center;
  box-sizing: border-box;
  width: 100%;
  max-width: 1280px;
  margin: 0 auto;
  padding: 1.5rem 1rem 0.25rem;
  display: flex;
  flex-direction: column;
  align-items: center;
  justify-content: center;
}
.pricing-header .pricing-title {
  font-size: 2.5rem;
  font-weight: 800;
  margin: 0 0 0.75rem;
  line-height: 1.2;
  color: #0f172a;
  max-width: 40rem;
  width: 100%;
}
@media (min-width: 768px) {
  .pricing-header .pricing-title {
    font-size: 3.25rem;
  }
}
.pricing-header .pricing-title .text-primary {
  color: #5ea1d8 !important;
}
.pricing-header .pricing-subtitle {
  max-width: 40rem;
  width: 100%;
  margin: 0 auto 1.75rem;
  font-size: 1.125rem;
  color: #64748b;
  line-height: 1.6;
}

.billing-toggle-container {
  display: flex;
  align-items: center;
  justify-content: center;
  gap: 1rem;
}
.billing-toggle-container .billing-label {
  font-size: 0.875rem;
  font-weight: 500;
  color: #64748b;
  transition: color 0.2s;
}
.billing-toggle-container .billing-label.active {
  color: #0f172a;
  font-weight: 600;
}
.billing-toggle-container .billing-label .discount-badge {
  display: inline-block;
  padding: 0.125rem 0.5rem;
  background-color: #dcfce7;
  color: #16a34a;
  font-size: 0.75rem;
  font-weight: 700;
  border-radius: 9999px;
  margin-left: 0.5rem;
}
.billing-toggle-container .billing-toggle {
  position: relative;
  width: 3.5rem;
  height: 1.75rem;
  background-color: #cbd5e1;
  border: none;
  border-radius: 9999px;
  padding: 0.25rem;
  cursor: pointer;
  transition: background-color 0.2s;
  outline: none;
}
.billing-toggle-container .billing-toggle:focus {
  outline: 2px solid #5ea1d8;
  outline-offset: 2px;
}
.billing-toggle-container .billing-toggle.active {
  background-color: #5ea1d8;
}
.billing-toggle-container .billing-toggle.active .toggle-dot {
  transform: translateX(1.75rem);
}
.billing-toggle-container .billing-toggle .toggle-dot {
  width: 1.25rem;
  height: 1.25rem;
  background-color: white;
  border-radius: 50%;
  box-shadow: 0 1px 2px rgba(0, 0, 0, 0.1);
  transition: transform 0.2s;
  display: block;
}

.billing-note {
  font-size: 0.7rem;
  margin-left: 0.25rem;
  color: #64748b;
}

.pricing-main {
  box-sizing: border-box;
  width: 100%;
  max-width: 1280px;
  margin: 0 auto;
  padding: 0 1rem;
}

.pricing-main .section-header {
  text-align: center;
  display: flex;
  flex-direction: column;
  align-items: center;
  margin-bottom: 1.75rem;
}
.pricing-main .section-header .section-kicker {
  margin: 0 0 0.45rem;
  font-size: 0.75rem;
  font-weight: 700;
  letter-spacing: 0.08em;
  text-transform: uppercase;
  color: #5ea1d8;
}
.pricing-main .section-header .section-title {
  font-size: 1.875rem;
  font-weight: 700;
  margin: 0 0 0.5rem;
  color: #0f172a;
  max-width: 40rem;
  width: 100%;
  line-height: 1.25;
}
.pricing-main .section-header .section-subtitle {
  margin: 0 auto;
  max-width: 40rem;
  width: 100%;
  color: #64748b;
  font-size: 1.125rem;
  line-height: 1.6;
}

.individual-plans-section {
  margin-bottom: 5rem;
}

.individual-plans {
  display: grid;
  grid-template-columns: 1fr;
  gap: 2rem;
}
@media (min-width: 768px) {
  .individual-plans {
    grid-template-columns: repeat(2, 1fr);
  }
}

.free-tier-section {
  margin: 0 0 3.25rem;
}

.free-tier-card {
  display: grid;
  grid-template-columns: 1fr;
  gap: 1.5rem;
  align-items: stretch;
  padding: 1.75rem;
  border-radius: 1rem;
  border: 1px solid #e2e8f0;
  background: #ffffff;
  box-shadow: 0 1px 2px rgba(15, 23, 42, 0.04);
}
@media (min-width: 900px) {
  .free-tier-card {
    grid-template-columns: minmax(0, 1.35fr) minmax(0, 1fr) 200px;
    gap: 0;
    padding: 0;
    min-height: 188px;
  }
}

.free-tier-col {
  min-width: 0;
}
@media (min-width: 900px) {
  .free-tier-col {
    padding: 1.75rem 1.5rem;
    display: flex;
    flex-direction: column;
    justify-content: center;
  }
}

@media (min-width: 900px) {
  .free-tier-col--info {
    padding-left: 2rem;
    padding-right: 1.75rem;
  }
}

.free-tier-col--features {
  list-style: none;
  margin: 0;
  padding: 0;
  display: flex;
  flex-direction: column;
  gap: 0.7rem;
}
@media (min-width: 900px) {
  .free-tier-col--features {
    border-left: 1px solid #e2e8f0;
    padding-left: 1.75rem;
    padding-right: 1.5rem;
  }
}
.free-tier-col--features .feature-item {
  display: flex;
  align-items: center;
  gap: 0.45rem;
  margin: 0;
  font-size: 0.9rem;
  color: #0f172a;
  line-height: 1.35;
}
.free-tier-col--features .feature-item .material-icons,
.free-tier-col--features .feature-item .check-icon {
  flex-shrink: 0;
  font-size: 1.1rem !important;
  color: #5ea1d8;
}
.free-tier-col--features .feature-item.disabled {
  color: #64748b;
}
.free-tier-col--features .feature-item.disabled .material-icons {
  color: #94a3b8;
}

.free-tier-col--cta {
  display: flex;
  flex-direction: column;
  align-items: stretch;
  gap: 0.7rem;
}
@media (min-width: 900px) {
  .free-tier-col--cta {
    border-left: 1px solid #e2e8f0;
    padding: 1.75rem 1.75rem 1.75rem 1.5rem;
    align-items: center;
    justify-content: center;
    text-align: center;
  }
}
.free-tier-col--cta .price-text {
  font-size: 1.15rem;
  font-weight: 700;
  color: #0f172a;
  line-height: 1.2;
  text-align: center;
}
.free-tier-col--cta .plan-button {
  width: 100%;
  max-width: 100%;
  padding: 0.8rem 1.1rem;
  font-weight: 700;
  border-radius: 0.75rem;
  cursor: pointer;
  transition: all 0.2s;
  font-size: 0.875rem;
  white-space: nowrap;
}
.free-tier-col--cta .plan-button.outline {
  border: 2px solid #e2e8f0;
  background-color: transparent;
  color: #0f172a;
}
.free-tier-col--cta .plan-button.outline:hover {
  border-color: #5ea1d8;
  color: #5ea1d8;
  background: rgba(94, 161, 216, 0.06);
}

.free-tier-identity {
  display: flex;
  align-items: flex-start;
  gap: 0.85rem;
  margin-bottom: 0.85rem;
}

.free-tier-icon {
  flex-shrink: 0;
  width: 2.75rem;
  height: 2.75rem;
  display: inline-flex;
  align-items: center;
  justify-content: center;
  border-radius: 0.85rem;
  background: rgba(94, 161, 216, 0.12);
  color: #5ea1d8;
  font-size: 1.4rem !important;
  line-height: 1;
}

.free-tier-titles {
  display: flex;
  flex-direction: column;
  align-items: flex-start;
  gap: 0.4rem;
  min-width: 0;
  padding-top: 0.1rem;
}
.free-tier-titles .plan-name {
  margin: 0 !important;
  font-size: 1.25rem !important;
  font-weight: 700 !important;
  color: #0f172a;
  line-height: 1.25;
}
.free-tier-titles .plan-tier-tag {
  display: inline-block;
  width: -moz-fit-content;
  width: fit-content;
  font-size: 0.6875rem;
  font-weight: 700;
  text-transform: uppercase;
  letter-spacing: 0.06em;
  color: #047857;
  background: #ecfdf5;
  padding: 0.2rem 0.625rem;
  border-radius: 999px;
}

.free-tier-col--info .plan-description {
  margin: 0;
  color: #64748b;
  font-size: 0.95rem;
  line-height: 1.55;
  max-width: 28rem;
}

.plan-card {
  padding: 2rem;
  border-radius: 1rem;
  border: 1px solid #e2e8f0;
  background-color: white;
  transition: all 0.3s;
  display: flex;
  flex-direction: column;
}
.plan-card:hover {
  box-shadow: 0 20px 25px -5px rgba(0, 0, 0, 0.1);
}
.plan-card.standard-plan {
  border: 1px solid #e2e8f0;
}
.plan-card.creator-plan {
  border: 2px solid #5ea1d8;
  box-shadow: 0 25px 50px -12px rgba(94, 161, 216, 0.1);
  position: relative;
}
.plan-card .plan-header {
  display: flex;
  flex-direction: row;
  flex-wrap: nowrap;
  align-items: flex-start;
  gap: 0.75rem;
  margin-bottom: 1rem;
}
.plan-card .plan-header .plan-icon {
  flex-shrink: 0;
  font-family: "Material Icons" !important;
  font-size: 1.5rem;
  line-height: 1;
  color: #64748b;
  margin-top: 0.125rem;
}
.plan-card .plan-header .plan-header-text {
  flex: 1;
  min-width: 0;
  display: flex;
  flex-direction: column;
  gap: 0.35rem;
}
.plan-card .plan-header .plan-name {
  font-size: 1.25rem !important;
  font-weight: 700 !important;
  font-family: inherit !important;
  margin: 0 !important;
  line-height: 1.3;
  color: #0f172a;
}
.plan-card .plan-tier-tag {
  display: inline-block;
  width: -moz-fit-content;
  width: fit-content;
  font-size: 0.6875rem;
  font-weight: 700;
  text-transform: uppercase;
  letter-spacing: 0.06em;
  color: #64748b;
  background: #f1f5f9;
  padding: 0.2rem 0.625rem;
  border-radius: 999px;
}
.plan-card .plan-tier-tag.creator {
  color: #4a92c8;
  background: rgba(94, 161, 216, 0.12);
}
.plan-card .plan-description {
  color: #64748b;
  margin-bottom: 1.5rem;
  min-height: 60px;
  line-height: 1.6;
}
.plan-card .plan-price {
  margin-bottom: 2rem;
}
.plan-card .plan-price .price-text {
  font-size: 1.875rem;
  font-weight: 700;
  font-style: italic;
  color: #0f172a;
}
.plan-card .plan-features {
  list-style: none;
  padding: 0;
  margin: 0 0 2rem;
  flex-grow: 1;
}
.plan-card .plan-features .feature-item {
  display: flex;
  align-items: flex-start;
  gap: 0.75rem;
  font-size: 0.875rem;
  margin-bottom: 1rem;
}
.plan-card .plan-features .feature-item .material-icons {
  flex-shrink: 0;
  font-family: "Material Icons" !important;
  font-size: 1.125rem;
  line-height: 1.4;
  color: #5ea1d8;
}
.plan-card .plan-features .feature-item.disabled {
  color: #64748b;
}
.plan-card .plan-features .feature-item.disabled .material-icons {
  color: #64748b;
}
.plan-card .plan-features .feature-item .check-icon {
  color: #5ea1d8;
}
.plan-card .plan-button {
  width: 100%;
  padding: 0.75rem;
  font-weight: 700;
  border-radius: 0.75rem;
  border: none;
  cursor: pointer;
  transition: all 0.2s;
  font-size: 0.875rem;
}
.plan-card .plan-button.outline {
  border: 2px solid #e2e8f0;
  background-color: transparent;
  color: #0f172a;
}
.plan-card .plan-button.outline:hover {
  border-color: #5ea1d8;
  color: #5ea1d8;
}
.plan-card .plan-button.primary {
  background-color: #5ea1d8;
  color: white;
  box-shadow: 0 10px 15px -3px rgba(94, 161, 216, 0.25);
}
.plan-card .plan-button.primary:hover {
  transform: scale(1.02);
  box-shadow: 0 20px 25px -5px rgba(94, 161, 216, 0.3);
}
.plan-card .plan-button.primary:active {
  transform: scale(0.98);
}
.plan-card .plan-button.current-plan {
  background-color: #ecfdf5;
  color: #047857;
  border: 1px solid #a7f3d0;
  cursor: default;
  box-shadow: none;
}
.plan-card .plan-button.current-plan:disabled {
  opacity: 1;
}

.business-solutions {
  margin-bottom: 5rem;
}
.business-solutions .section-header {
  margin-bottom: 3rem;
}
.business-solutions .section-header .business-billing-toggle {
  margin-top: 1.25rem;
}

.business-plans {
  display: grid;
  grid-template-columns: 1fr;
  gap: 2rem;
}
@media (min-width: 768px) {
  .business-plans {
    grid-template-columns: repeat(3, 1fr);
  }
}

.business-plan-card {
  padding: 2rem;
  border-radius: 1rem;
  background-color: white;
  border: 1px solid #e2e8f0;
  display: flex;
  flex-direction: column;
  position: relative;
  transition: all 0.3s;
}
.business-plan-card:hover {
  box-shadow: 0 4px 6px -1px rgba(0, 0, 0, 0.1);
}
.business-plan-card.growth-plan {
  border: 2px solid #e83e8c;
  box-shadow: 0 25px 50px -12px rgba(232, 62, 140, 0.1);
  transform: translateY(-1rem);
}
@media (max-width: 767px) {
  .business-plan-card.growth-plan {
    transform: none;
  }
}
.business-plan-card.growth-plan .popular-badge {
  position: absolute;
  top: 0;
  right: 0;
  background-color: #e83e8c;
  color: white;
  padding: 0.25rem 1rem;
  font-size: 0.75rem;
  font-weight: 700;
  border-bottom-left-radius: 0.75rem;
  border-top-right-radius: 0.75rem;
  letter-spacing: 0.05em;
  text-transform: uppercase;
  overflow: hidden;
  pointer-events: none;
  z-index: 1;
}
.business-plan-card .plan-header {
  margin-bottom: 1.5rem;
}
.business-plan-card .plan-header .plan-label {
  font-weight: 700;
  color: #64748b;
  text-transform: uppercase;
  letter-spacing: 0.1em;
  font-size: 0.75rem;
  margin-bottom: 0.5rem;
}
.business-plan-card .plan-header .plan-price {
  display: flex;
  align-items: baseline;
  gap: 0.25rem;
  flex-wrap: wrap;
}
.business-plan-card .plan-header .plan-price .price-amount {
  font-size: 2.25rem;
  font-weight: 800;
  color: #0f172a;
}
.business-plan-card .plan-header .plan-price .price-period {
  color: #64748b;
  font-size: 1rem;
}
.business-plan-card .plan-header .plan-price .price-old {
  font-size: 1.125rem;
  font-weight: 600;
  color: #64748b;
  text-decoration: line-through;
  margin-right: 0.5rem;
}
.business-plan-card .plan-header .plan-price .price-new {
  color: #e83e8c;
}
.business-plan-card .plan-audience {
  padding: 0.75rem 0;
  border-top: 1px solid #f1f5f9;
  border-bottom: 1px solid #f1f5f9;
  margin-bottom: 1.5rem;
}
.business-plan-card .plan-audience .audience-label {
  font-size: 0.75rem;
  font-weight: 600;
  color: #64748b;
  text-transform: uppercase;
  letter-spacing: 0.05em;
  margin-bottom: 0.25rem;
}
.business-plan-card .plan-audience .audience-text {
  font-size: 0.875rem;
  color: #0f172a;
  margin: 0;
}
.business-plan-card .plan-features {
  list-style: none;
  padding: 0;
  margin: 0 0 2.5rem;
  flex-grow: 1;
}
.business-plan-card .plan-features .feature-item {
  display: flex;
  align-items: flex-start;
  gap: 0.75rem;
  font-size: 0.875rem;
  margin-bottom: 1rem;
}
.business-plan-card .plan-features .feature-item .material-icons {
  font-size: 0.875rem;
  margin-top: 0.125rem;
  color: #5ea1d8;
}
.business-plan-card .plan-features .feature-item.info {
  color: #64748b;
}
.business-plan-card .plan-features .feature-item.info .material-icons {
  color: #64748b;
}
.business-plan-card .plan-features .feature-item .font-medium {
  font-weight: 500;
}
.business-plan-card .plan-button {
  width: 100%;
  padding: 0.75rem;
  font-weight: 700;
  border-radius: 0.75rem;
  border: none;
  cursor: pointer;
  transition: all 0.2s;
  font-size: 0.875rem;
  position: relative;
  z-index: 2;
  pointer-events: auto;
}
.business-plan-card .plan-button.dark {
  background-color: #0f172a;
  color: white;
}
.business-plan-card .plan-button.dark:hover {
  opacity: 0.9;
}
.business-plan-card .plan-button.accent {
  background-color: #e83e8c;
  color: white;
  box-shadow: 0 10px 15px -3px rgba(232, 62, 140, 0.25);
}
.business-plan-card .plan-button.accent:hover {
  box-shadow: 0 20px 25px -5px rgba(232, 62, 140, 0.3);
}
.business-plan-card .plan-button.outline {
  border: 2px solid #e2e8f0;
  background-color: transparent;
  color: #0f172a;
}
.business-plan-card .plan-button.outline:hover {
  border-color: #0f172a;
  color: #0f172a;
}

.ai-coins-section,
.guide-topups-section {
  margin: 0 0 5rem;
  padding: 2rem 1.5rem;
  border-radius: 1.25rem;
  background: linear-gradient(180deg, rgba(232, 62, 140, 0.06) 0%, rgba(94, 161, 216, 0.04) 100%);
  border: 1px solid rgba(232, 62, 140, 0.12);
  scroll-margin-top: 5rem;
}
.ai-coins-section .section-header,
.guide-topups-section .section-header {
  display: flex;
  align-items: flex-start;
  gap: 0.85rem;
  margin-bottom: 1.75rem;
}
.ai-coins-section .section-header .section-icon,
.guide-topups-section .section-header .section-icon {
  flex-shrink: 0;
  width: 2.5rem;
  height: 2.5rem;
  border-radius: 0.75rem;
  display: inline-flex;
  align-items: center;
  justify-content: center;
  background: rgba(232, 62, 140, 0.12);
  color: #e83e8c;
  font-size: 1.35rem;
}
.ai-coins-section .section-header .section-header-text,
.guide-topups-section .section-header .section-header-text {
  flex: 1;
  min-width: 0;
}
.ai-coins-section .section-header .section-title,
.guide-topups-section .section-header .section-title {
  margin: 0 0 0.4rem;
  font-size: 1.5rem;
  font-weight: 700;
  color: #0f172a;
}
.ai-coins-section .section-header .section-subtitle,
.guide-topups-section .section-header .section-subtitle {
  margin: 0;
  color: #64748b;
  line-height: 1.55;
  max-width: 720px;
  font-size: 0.95rem;
}

.coin-balance-banner {
  display: flex;
  align-items: center;
  justify-content: space-between;
  gap: 1rem;
  flex-wrap: wrap;
  padding: 1rem 1.35rem;
  margin-bottom: 1.75rem;
  border-radius: 14px;
  background: #ffffff;
  border: 1px solid rgba(94, 161, 216, 0.22);
  box-shadow: 0 2px 10px rgba(15, 23, 42, 0.04);
}
.coin-balance-banner .balance-label {
  font-size: 0.75rem;
  text-transform: uppercase;
  letter-spacing: 0.06em;
  color: #64748b;
  font-weight: 700;
}
.coin-balance-banner .balance-value {
  font-size: 1.2rem;
  font-weight: 700;
  color: #0f172a;
}
.coin-balance-banner .balance-detail {
  font-size: 0.85rem;
  font-weight: 500;
  color: #64748b;
  margin-left: 0.35rem;
}

.coin-packs-grid {
  display: grid;
  grid-template-columns: 1fr;
  gap: 1.25rem;
}
@media (min-width: 768px) {
  .coin-packs-grid {
    grid-template-columns: repeat(3, 1fr);
  }
}

.coin-pack-card {
  position: relative;
  padding: 1.6rem 1.4rem 1.4rem;
  border-radius: 1rem;
  background: #ffffff;
  border: 1px solid #e2e8f0;
  display: flex;
  flex-direction: column;
  gap: 0.85rem;
  box-shadow: 0 4px 14px rgba(15, 23, 42, 0.05);
  transition: transform 0.2s ease, box-shadow 0.2s ease, border-color 0.2s ease;
  overflow: hidden;
}
.coin-pack-card:hover {
  transform: translateY(-3px);
  box-shadow: 0 12px 28px rgba(232, 62, 140, 0.12);
  border-color: rgba(232, 62, 140, 0.35);
}
.coin-pack-card.featured {
  border-color: #e83e8c;
  box-shadow: 0 10px 28px rgba(232, 62, 140, 0.14);
}
.coin-pack-card .coin-pack-badge {
  position: absolute;
  top: 0;
  right: 0;
  padding: 0.35rem 0.75rem;
  border-radius: 0 0.9rem 0 0.75rem;
  background: #e83e8c;
  color: #ffffff;
  font-size: 0.65rem;
  font-weight: 700;
  letter-spacing: 0.04em;
  text-transform: uppercase;
  line-height: 1.2;
}
.coin-pack-card .coin-pack-icon {
  width: 2.75rem;
  height: 2.75rem;
  border-radius: 0.85rem;
  display: inline-flex;
  align-items: center;
  justify-content: center;
  background: rgba(232, 62, 140, 0.1);
  color: #e83e8c;
}
.coin-pack-card .coin-pack-icon .material-icons {
  font-size: 1.35rem;
  color: inherit;
}
.coin-pack-card .coin-pack-header {
  display: flex;
  align-items: baseline;
  justify-content: space-between;
  gap: 0.5rem;
}
.coin-pack-card .coin-pack-name {
  margin: 0;
  font-size: 1.05rem;
  font-weight: 700;
  color: #0f172a;
}
.coin-pack-card .coin-pack-amount {
  font-size: 0.85rem;
  font-weight: 700;
  color: #e83e8c;
  white-space: nowrap;
  background: rgba(232, 62, 140, 0.1);
  padding: 0.2rem 0.55rem;
  border-radius: 999px;
}
.coin-pack-card .coin-pack-description {
  margin: 0;
  font-size: 0.875rem;
  color: #64748b;
  line-height: 1.55;
  flex: 1;
}
.coin-pack-card .coin-pack-price {
  display: flex;
  align-items: baseline;
  gap: 0.4rem;
  padding-top: 0.35rem;
  border-top: 1px solid #f1f5f9;
}
.coin-pack-card .coin-pack-price .price-amount {
  font-size: 1.65rem;
  font-weight: 800;
  color: #0f172a;
  letter-spacing: -0.02em;
}
.coin-pack-card .coin-pack-price .price-unit {
  font-size: 0.7rem;
  text-transform: uppercase;
  letter-spacing: 0.05em;
  color: #64748b;
  font-weight: 700;
}
.coin-pack-card .coin-buy-btn {
  margin-top: 0.25rem;
  width: 100%;
  padding: 0.75rem;
  font-weight: 700;
  font-size: 0.875rem;
  border-radius: 0.75rem;
  border: 2px solid #e83e8c !important;
  background-color: transparent;
  color: #e83e8c !important;
  cursor: pointer;
  transition: all 0.2s;
}
.coin-pack-card .coin-buy-btn:hover {
  background: rgba(232, 62, 140, 0.1) !important;
  border-color: #e83e8c !important;
  color: #c2185b !important;
}

.coin-footnote {
  margin: 1.75rem 0 0;
  font-size: 0.9rem;
  color: #64748b;
  text-align: center;
  line-height: 1.55;
}
.coin-footnote .inline-link {
  border: none;
  background: none;
  padding: 0;
  color: #e83e8c;
  font-weight: 700;
  cursor: pointer;
  text-decoration: underline;
  text-underline-offset: 2px;
}
.coin-footnote .inline-link:hover {
  color: #c2185b;
}

.add-ons-section {
  margin-bottom: 6rem;
}
.add-ons-section .section-header {
  display: flex;
  flex-direction: row;
  flex-wrap: nowrap;
  align-items: center;
  gap: 0.5rem;
  margin-bottom: 2rem;
}
.add-ons-section .section-header .section-icon {
  flex-shrink: 0;
  display: inline-flex;
  align-items: center;
  justify-content: center;
  line-height: 1;
  color: #e83e8c;
  font-size: 1.25rem;
  width: 1.25rem;
  height: 1.25rem;
}
.add-ons-section .section-header .section-title {
  flex: 1 1 auto;
  min-width: 0;
  width: auto;
  font-size: 1.25rem !important;
  font-weight: 700 !important;
  font-family: inherit !important;
  margin: 0 !important;
  line-height: 1.3;
  color: #0f172a;
}

.add-ons-grid {
  display: grid;
  grid-template-columns: 1fr;
  gap: 1.5rem;
}
@media (min-width: 1024px) {
  .add-ons-grid {
    grid-template-columns: repeat(3, 1fr);
  }
}

.add-on-card {
  padding: 1.5rem;
  border-radius: 0.75rem;
  background-color: white;
  border: 1px solid #f1f5f9;
  display: flex;
  flex-direction: column;
  height: 100%;
  box-shadow: 0 1px 2px rgba(0, 0, 0, 0.05);
  transition: box-shadow 0.2s;
}
.add-on-card:hover {
  box-shadow: 0 4px 6px -1px rgba(0, 0, 0, 0.1);
}
.add-on-card .add-on-title {
  font-weight: 700;
  margin-bottom: 0.5rem;
  color: #0f172a;
  font-size: 1rem;
}
.add-on-card .add-on-description {
  font-size: 0.875rem;
  color: #64748b;
  margin-bottom: 1.5rem;
  flex-grow: 1;
  line-height: 1.5;
}
.add-on-card .add-on-price {
  display: flex;
  align-items: center;
  justify-content: space-between;
  padding-top: 1rem;
  border-top: 1px solid #f8fafc;
}
.add-on-card .add-on-price .price-text {
  font-size: 0.875rem;
  font-weight: 600;
  color: #0f172a;
}
.add-on-card .add-on-price .price-unit {
  font-size: 0.75rem;
  color: #64748b;
  text-transform: uppercase;
}

.img-div-left {
  display: flex;
  justify-content: center;
  align-items: center;
  min-height: 50vh;
}

.spinner-global {
  width: 50px;
  height: 50px;
}

@media (max-width: 767px) {
  .pricing-header {
    padding: 1rem 1rem 1rem;
  }
  .pricing-header .pricing-title {
    font-size: 2rem;
  }
  .plan-card,
  .business-plan-card {
    padding: 1.5rem;
  }
}
.trial-banner {
  display: flex;
  align-items: center;
  gap: 1rem;
  max-width: 1100px;
  margin: 0 auto 2.5rem;
  padding: 1rem 1.25rem;
  border-radius: 1rem;
  border: 1px solid rgba(94, 161, 216, 0.35);
  background: linear-gradient(90deg, rgba(94, 161, 216, 0.12) 0%, rgba(22, 101, 52, 0.08) 100%);
}
.trial-banner .trial-banner-icon {
  color: #4a92c8;
  font-size: 1.75rem;
}
.trial-banner .trial-banner-text {
  display: flex;
  flex-direction: column;
  gap: 0.2rem;
  flex: 1;
  font-size: 0.95rem;
  color: #0f172a;
}
.trial-banner .trial-banner-btn {
  width: auto;
  padding: 0.7rem 1.25rem;
  border: none;
  border-radius: 0.75rem;
  background-color: #0f172a;
  color: #fff;
  font-weight: 700;
  cursor: pointer;
  white-space: nowrap;
}
.trial-banner .trial-banner-btn:disabled {
  opacity: 0.6;
}
@media (max-width: 640px) {
  .trial-banner {
    flex-direction: column;
    align-items: flex-start;
  }
}

.business-plan-card .plan-trial-line {
  display: flex;
  align-items: center;
  flex-wrap: wrap;
  gap: 0.25rem 0.5rem;
  margin: 0.5rem 0 0;
  font-size: 0.8rem;
  line-height: 1.3;
  color: #64748b;
}
.business-plan-card .plan-trial-line .plan-trial-pill {
  padding: 0.15rem 0.5rem;
  border-radius: 999px;
  background: #dcfce7;
  color: #166534;
  font-size: 0.7rem;
  font-weight: 700;
  text-transform: uppercase;
  letter-spacing: 0.04em;
  white-space: nowrap;
}

.business-plan-card .plan-skip-trial {
  display: block;
  width: 100%;
  margin-top: 0.4rem;
  padding: 0;
  border: none;
  background: none;
  color: #64748b;
  font-size: 0.8rem;
  font-weight: 600;
  text-decoration: underline;
  cursor: pointer;
}
.business-plan-card .plan-skip-trial:hover {
  color: #0f172a;
}
.business-plan-card .plan-skip-trial:disabled {
  opacity: 0.6;
  cursor: default;
}`, "",{"version":3,"sources":["webpack://./src/app/pages/pricingplan/pricingplan.component.scss"],"names":[],"mappings":"AAAA,gBAAgB;AAUhB;EACE,iBAAA;EACA,yBATiB;EAWjB,oBAAA;AATF;;AAYA,cAAA;AACA;EA0FE,gEAAA;EA4BA,iCAAA;AA7HF;AAQE;EACE,8BAAA;EACA,yBAAA;AANJ;AASE;;;;;;EAME,yBAAA;AAPJ;AAUE;;;;;;EAME,yBAAA;AARJ;AAWE;EACE,yBAAA;AATJ;AAYE;EACE,yBAAA;AAVJ;AAaE;EACE,oCAAA;AAXJ;AAcE;EACE,oCAAA;EACA,yBAAA;EACA,2CAAA;AAZJ;AAeE;;;;;;EAME,8BAAA;EACA,kDAAA;EACA,2BAAA;AAbJ;AAgBE;EACE,+CAAA;EACA,yBAAA;AAdJ;AAiBE;EACE,yBAAA;EACA,4CAAA;AAfJ;AAoBI;EAFF;;IAGI,uDAAA;EAhBJ;AACF;AAmBE;EACE,yBAAA;AAjBJ;AAoBE;EACE,gCAAA;AAlBJ;AAqBE;;EAEE,kCAAA;EACA,gCAAA;EACA,yBAAA;AAnBJ;AAsBE;;EAEE,+CAAA;AApBJ;AAwBE;;;;;EAKE,yBAAA;AAtBJ;AAyBE;EACE,yBAAA;AAvBJ;AA0BE;;;EAGE,yBAAA;AAxBJ;AA2BE;;EAEE,yBAAA;AAzBJ;AA4BE;EACE,sDAAA;AA1BJ;AA8BE;;EAEE,uGAAA;EAKA,iDAAA;AAhCJ;AAmCE;;;;EAIE,yBAAA;AAjCJ;AAoCE;;;;;;EAME,yBAAA;AAlCJ;AAqCE;;;EAGE,yBAAA;AAnCJ;AAsCE;EACE,kGAAA;EAKA,kDAAA;AAxCJ;AA2CE;EACE,8BAAA;EACA,kDAAA;EACA,2BAAA;AAzCJ;AA2CI;EACE,iDAAA;EACA,qDAAA;AAzCN;AA4CI;EACE,gCAAA;EACA,wFAAA;AA1CN;AAkDE;EACE,+CAAA;EACA,yBAAA;AAhDJ;AAmDE;EACE,8BAAA;EACA,yBAAA;AAjDJ;AAoDE;EACE,8BAAA;EACA,yBAAA;AAlDJ;AAoDI;EACE,8CAAA;EACA,yBAAA;AAlDN;AAsDE;;;EAGE,yBAAA;AApDJ;AAuDE;;EAEE,yBAAA;AArDJ;AAwDE;;;EAGE,yBAAA;AAtDJ;AAyDE;EACE,yBAAA;AAvDJ;AA0DE;EACE,yBAAA;AAxDJ;AA2DE;;;;;EAKE,yBAAA;AAzDJ;AA4DE;;EAEE,8BAAA;EACA,yBAAA;AA1DJ;AA6DE;;EAEE,8BAAA;EACA,yBAAA;EACA,kDAAA;AA3DJ;;AAgEA;EACE,mBAAA;EACA,cAAA;EACA,eAAA;EACA,6BAAA;AA7DF;AA+DE;EACE,iBAAA;EACA,cAAA;EACA,eAAA;EACA,WAAA;AA7DJ;AA+DI;EACE,aAAA;EACA,mBAAA;EACA,SAAA;EACA,WAAA;AA7DN;AA+DM;EANF;IAOI,sBAAA;IACA,uBAAA;IACA,SAAA;EA5DN;AACF;AA+DI;;;EAGE,UAAA;EACA,aAAA;EACA,mBAAA;AA7DN;AA+DM;EAPF;;;IAQI,WAAA;IACA,2BAAA;EA1DN;AACF;AA8DM;EADF;IAEI,2BAAA;EA3DN;AACF;AA+DM;EADF;IAEI,yBAAA;EA5DN;AACF;AAgEE;EACE,yBAAA;EACA,gBAAA;EACA,UAAA;EACA,SAAA;EACA,aAAA;EACA,mBAAA;EACA,eAAA;EACA,gBAAA;EACA,WAAA;AA9DJ;AAgEI;EAXF;IAYI,eAAA;EA7DJ;AACF;AA+DI;EACE,yBAAA;EACA,SAAA;EACA,UAAA;EACA,aAAA;EACA,mBAAA;EACA,eAAA;AA7DN;AA+DM;EACE,yBAAA;EACA,qBAAA;EACA,gBAAA;AA7DR;AA+DQ;EACE,yBAAA;EACA,0BAAA;AA7DV;AAmEE;EACE,aAAA;EACA,gBAAA;EACA,UAAA;EACA,SAAA;EACA,mBAAA;EACA,yBAAA;EACA,eAAA;EACA,MAAA;EACA,WAAA;AAjEJ;AAmEI;EAXF;IAYI,2BAAA;IACA,sBAAA;IACA,uBAAA;IACA,QAAA;EAhEJ;AACF;AAkEI;EACE,SAAA;EACA,UAAA;AAhEN;AAkEM;EACE;IACE,YAAA;IACA,cAAA;IACA,cAAA;EAhER;AACF;AAmEM;EACE,yBAAA;EACA,qBAAA;EACA,eAAA;EACA,2BAAA;AAjER;AAmEQ;EACE,yBAAA;EACA,0BAAA;AAjEV;;AAyEE;EACE,8BAAA;EACA,yBAAA;EACA,0DAAA;AAtEJ;AAwEI;;;;EAIE,yBAAA;AAtEN;AAyEI;;EAEE,yBAAA;AAvEN;AA0EI;EACE,cAAA;AAxEN;;AAmFA;EACE,kBAAA;EACA,sBAAA;EACA,WAAA;EACA,iBAToB;EAUpB,cAAA;EACA,4BAAA;EACA,aAAA;EACA,sBAAA;EACA,mBAAA;EACA,uBAAA;AAhFF;AAkFE;EACE,iBAAA;EACA,gBAAA;EACA,mBAAA;EACA,gBAAA;EACA,cAxbQ;EAybR,gBArBe;EAsBf,WAAA;AAhFJ;AAkFI;EATF;IAUI,kBAAA;EA/EJ;AACF;AAiFI;EAEE,yBAAA;AAhFN;AAoFE;EACE,gBAnCe;EAoCf,WAAA;EACA,sBAAA;EACA,mBAAA;EACA,cA1cS;EA2cT,gBAAA;AAlFJ;;AAsFA;EACE,aAAA;EACA,mBAAA;EACA,uBAAA;EACA,SAAA;AAnFF;AAqFE;EACE,mBAAA;EACA,gBAAA;EACA,cAxdS;EAydT,sBAAA;AAnFJ;AAqFI;EACE,cA7dM;EA8dN,gBAAA;AAnFN;AAsFI;EACE,qBAAA;EACA,wBAAA;EACA,yBAAA;EACA,cAAA;EACA,kBAAA;EACA,gBAAA;EACA,qBAAA;EACA,mBAAA;AApFN;AAwFE;EACE,kBAAA;EACA,aAAA;EACA,eAAA;EACA,yBAAA;EACA,YAAA;EACA,qBAAA;EACA,gBAAA;EACA,eAAA;EACA,iCAAA;EACA,aAAA;AAtFJ;AAwFI;EACE,0BAAA;EACA,mBAAA;AAtFN;AAyFI;EACE,yBAngBU;AA4ahB;AAyFM;EACE,8BAAA;AAvFR;AA2FI;EACE,cAAA;EACA,eAAA;EACA,uBAAA;EACA,kBAAA;EACA,wCAAA;EACA,0BAAA;EACA,cAAA;AAzFN;;AA8FA;EACE,iBAAA;EACA,oBAAA;EACA,cAphBW;AAybb;;AA+FA;EACE,sBAAA;EACA,WAAA;EACA,iBA1HoB;EA2HpB,cAAA;EACA,eAAA;AA5FF;;AAgGA;EACE,kBAAA;EACA,aAAA;EACA,sBAAA;EACA,mBAAA;EACA,sBAAA;AA7FF;AA+FE;EACE,mBAAA;EACA,kBAAA;EACA,gBAAA;EACA,sBAAA;EACA,yBAAA;EACA,cAnjBY;AAsdhB;AAgGE;EACE,mBAAA;EACA,gBAAA;EACA,kBAAA;EACA,cAtjBQ;EAujBR,gBAnJe;EAoJf,WAAA;EACA,iBAAA;AA9FJ;AAiGE;EACE,cAAA;EACA,gBA1Je;EA2Jf,WAAA;EACA,cA/jBS;EAgkBT,mBAAA;EACA,gBAAA;AA/FJ;;AAoGA;EACE,mBAAA;AAjGF;;AAoGA;EACE,aAAA;EACA,0BAAA;EACA,SAAA;AAjGF;AAmGE;EALF;IAMI,qCAAA;EAhGF;AACF;;AAoGA;EACE,mBAAA;AAjGF;;AAoGA;EACE,aAAA;EACA,0BAAA;EACA,WAAA;EACA,oBAAA;EACA,gBAAA;EACA,mBAAA;EACA,yBAAA;EACA,mBAAA;EACA,4CAAA;AAjGF;AAmGE;EAXF;IAYI,6DAAA;IACA,MAAA;IACA,UAAA;IACA,iBAAA;EAhGF;AACF;;AAmGA;EACE,YAAA;AAhGF;AAkGE;EAHF;IAII,uBAAA;IACA,aAAA;IACA,sBAAA;IACA,uBAAA;EA/FF;AACF;;AAmGE;EADF;IAEI,kBAAA;IACA,sBAAA;EA/FF;AACF;;AAkGA;EACE,gBAAA;EACA,SAAA;EACA,UAAA;EACA,aAAA;EACA,sBAAA;EACA,WAAA;AA/FF;AAiGE;EARF;IASI,8BAAA;IACA,qBAAA;IACA,qBAAA;EA9FF;AACF;AAgGE;EACE,aAAA;EACA,mBAAA;EACA,YAAA;EACA,SAAA;EACA,iBAAA;EACA,cAnpBQ;EAopBR,iBAAA;AA9FJ;AAgGI;;EAEE,cAAA;EACA,4BAAA;EACA,cA9pBU;AAgkBhB;AAiGI;EACE,cA7pBO;AA8jBb;AAiGM;EACE,cAAA;AA/FR;;AAqGA;EACE,aAAA;EACA,sBAAA;EACA,oBAAA;EACA,WAAA;AAlGF;AAoGE;EANF;IAOI,8BAAA;IACA,uCAAA;IACA,mBAAA;IACA,uBAAA;IACA,kBAAA;EAjGF;AACF;AAmGE;EACE,kBAAA;EACA,gBAAA;EACA,cAxrBQ;EAyrBR,gBAAA;EACA,kBAAA;AAjGJ;AAoGE;EACE,WAAA;EACA,eAAA;EACA,sBAAA;EACA,gBAAA;EACA,sBAAA;EACA,eAAA;EACA,oBAAA;EACA,mBAAA;EACA,mBAAA;AAlGJ;AAoGI;EACE,yBAAA;EACA,6BAAA;EACA,cA3sBM;AAymBZ;AAoGM;EACE,qBAltBQ;EAmtBR,cAntBQ;EAotBR,oCAAA;AAlGR;;AAwGA;EACE,aAAA;EACA,uBAAA;EACA,YAAA;EACA,sBAAA;AArGF;;AAwGA;EACE,cAAA;EACA,cAAA;EACA,eAAA;EACA,oBAAA;EACA,mBAAA;EACA,uBAAA;EACA,sBAAA;EACA,oCAAA;EACA,cA1uBc;EA2uBd,4BAAA;EACA,cAAA;AArGF;;AAwGA;EACE,aAAA;EACA,sBAAA;EACA,uBAAA;EACA,WAAA;EACA,YAAA;EACA,mBAAA;AArGF;AAuGE;EACE,oBAAA;EACA,6BAAA;EACA,2BAAA;EACA,cAvvBQ;EAwvBR,iBAAA;AArGJ;AAwGE;EACE,qBAAA;EACA,uBAAA;EAAA,kBAAA;EACA,oBAAA;EACA,gBAAA;EACA,yBAAA;EACA,sBAAA;EACA,cAAA;EACA,mBAAA;EACA,wBAAA;EACA,oBAAA;AAtGJ;;AA0GA;EACE,SAAA;EACA,cA1wBW;EA2wBX,kBAAA;EACA,iBAAA;EACA,gBAAA;AAvGF;;AA0GA;EACE,aAAA;EACA,mBAAA;EACA,yBAAA;EACA,uBAAA;EACA,oBAAA;EACA,aAAA;EACA,sBAAA;AAvGF;AAyGE;EACE,+CAAA;AAvGJ;AA0GE;EACE,yBAAA;AAxGJ;AA2GE;EACE,yBAAA;EACA,qDAAA;EACA,kBAAA;AAzGJ;AA4GE;EACE,aAAA;EACA,mBAAA;EACA,iBAAA;EACA,uBAAA;EACA,YAAA;EACA,mBAAA;AA1GJ;AA4GI;EACE,cAAA;EACA,wCAAA;EACA,iBAAA;EACA,cAAA;EACA,cApzBO;EAqzBP,oBAAA;AA1GN;AA6GI;EACE,OAAA;EACA,YAAA;EACA,aAAA;EACA,sBAAA;EACA,YAAA;AA3GN;AA8GI;EACE,6BAAA;EACA,2BAAA;EACA,+BAAA;EACA,oBAAA;EACA,gBAAA;EACA,cAv0BM;AA2tBZ;AAgHE;EACE,qBAAA;EACA,uBAAA;EAAA,kBAAA;EACA,oBAAA;EACA,gBAAA;EACA,yBAAA;EACA,sBAAA;EACA,cAAA;EACA,mBAAA;EACA,wBAAA;EACA,oBAAA;AA9GJ;AAgHI;EACE,cAAA;EACA,oCAAA;AA9GN;AAkHE;EACE,cA71BS;EA81BT,qBAAA;EACA,gBAAA;EACA,gBAAA;AAhHJ;AAmHE;EACE,mBAAA;AAjHJ;AAmHI;EACE,mBAAA;EACA,gBAAA;EACA,kBAAA;EACA,cA32BM;AA0vBZ;AAqHE;EACE,gBAAA;EACA,UAAA;EACA,gBAAA;EACA,YAAA;AAnHJ;AAqHI;EACE,aAAA;EACA,uBAAA;EACA,YAAA;EACA,mBAAA;EACA,mBAAA;AAnHN;AAqHM;EACE,cAAA;EACA,wCAAA;EACA,mBAAA;EACA,gBAAA;EACA,cAr4BQ;AAkxBhB;AAsHM;EACE,cAp4BK;AAgxBb;AAsHQ;EACE,cAv4BG;AAmxBb;AAwHM;EACE,cAj5BQ;AA2xBhB;AA2HE;EACE,WAAA;EACA,gBAAA;EACA,gBAAA;EACA,sBAAA;EACA,YAAA;EACA,eAAA;EACA,oBAAA;EACA,mBAAA;AAzHJ;AA2HI;EACE,yBAAA;EACA,6BAAA;EACA,cA/5BM;AAsyBZ;AA2HM;EACE,qBAt6BQ;EAu6BR,cAv6BQ;AA8yBhB;AA6HI;EACE,yBA56BU;EA66BV,YAAA;EACA,qDAAA;AA3HN;AA6HM;EACE,sBAAA;EACA,oDAAA;AA3HR;AA8HM;EACE,sBAAA;AA5HR;AAgII;EACE,yBAAA;EACA,cAAA;EACA,yBAAA;EACA,eAAA;EACA,gBAAA;AA9HN;AAgIM;EACE,UAAA;AA9HR;;AAqIA;EACE,mBAAA;AAlIF;AAoIE;EACE,mBAAA;AAlIJ;AAoII;EACE,mBAAA;AAlIN;;AAuIA;EACE,aAAA;EACA,0BAAA;EACA,SAAA;AApIF;AAsIE;EALF;IAMI,qCAAA;EAnIF;AACF;;AAsIA;EACE,aAAA;EACA,mBAAA;EACA,uBAAA;EACA,yBAAA;EACA,aAAA;EACA,sBAAA;EACA,kBAAA;EACA,oBAAA;AAnIF;AAqIE;EACE,6CAAA;AAnIJ;AAsIE;EACE,yBAAA;EACA,qDAAA;EACA,4BAAA;AApIJ;AAsII;EALF;IAMI,eAAA;EAnIJ;AACF;AAqII;EACE,kBAAA;EACA,MAAA;EACA,QAAA;EACA,yBAz/BS;EA0/BT,YAAA;EACA,qBAAA;EACA,kBAAA;EACA,gBAAA;EACA,kCAAA;EACA,gCAAA;EACA,sBAAA;EACA,yBAAA;EACA,gBAAA;EACA,oBAAA;EACA,UAAA;AAnIN;AAuIE;EACE,qBAAA;AArIJ;AAuII;EACE,gBAAA;EACA,cAzgCO;EA0gCP,yBAAA;EACA,qBAAA;EACA,kBAAA;EACA,qBAAA;AArIN;AAwII;EACE,aAAA;EACA,qBAAA;EACA,YAAA;EACA,eAAA;AAtIN;AAwIM;EACE,kBAAA;EACA,gBAAA;EACA,cA1hCI;AAo5BZ;AAyIM;EACE,cA7hCK;EA8hCL,eAAA;AAvIR;AA0IM;EACE,mBAAA;EACA,gBAAA;EACA,cApiCK;EAqiCL,6BAAA;EACA,oBAAA;AAxIR;AA2IM;EACE,cA9iCO;AAq6Bf;AA8IE;EACE,kBAAA;EACA,6BAAA;EACA,gCAAA;EACA,qBAAA;AA5IJ;AA8II;EACE,kBAAA;EACA,gBAAA;EACA,cAxjCO;EAyjCP,yBAAA;EACA,sBAAA;EACA,sBAAA;AA5IN;AA+II;EACE,mBAAA;EACA,cAjkCM;EAkkCN,SAAA;AA7IN;AAiJE;EACE,gBAAA;EACA,UAAA;EACA,kBAAA;EACA,YAAA;AA/IJ;AAiJI;EACE,aAAA;EACA,uBAAA;EACA,YAAA;EACA,mBAAA;EACA,mBAAA;AA/IN;AAiJM;EACE,mBAAA;EACA,oBAAA;EACA,cA1lCQ;AA28BhB;AAkJM;EACE,cAzlCK;AAy8Bb;AAkJQ;EACE,cA5lCG;AA48Bb;AAoJM;EACE,gBAAA;AAlJR;AAuJE;EACE,WAAA;EACA,gBAAA;EACA,gBAAA;EACA,sBAAA;EACA,YAAA;EACA,eAAA;EACA,oBAAA;EACA,mBAAA;EACA,kBAAA;EACA,UAAA;EACA,oBAAA;AArJJ;AAuJI;EACE,yBArnCM;EAsnCN,YAAA;AArJN;AAuJM;EACE,YAAA;AArJR;AAyJI;EACE,yBAjoCS;EAkoCT,YAAA;EACA,qDAAA;AAvJN;AAyJM;EACE,oDAAA;AAvJR;AA2JI;EACE,yBAAA;EACA,6BAAA;EACA,cA1oCM;AAi/BZ;AA2JM;EACE,qBA7oCI;EA8oCJ,cA9oCI;AAq/BZ;;AAgKA;;EAEE,gBAAA;EACA,oBAAA;EACA,sBAAA;EACA,+FAAA;EAKA,0CAAA;EACA,uBAAA;AAjKF;AAmKE;;EACE,aAAA;EACA,uBAAA;EACA,YAAA;EACA,sBAAA;AAhKJ;AAkKI;;EACE,cAAA;EACA,aAAA;EACA,cAAA;EACA,sBAAA;EACA,oBAAA;EACA,mBAAA;EACA,uBAAA;EACA,oCAAA;EACA,cAprCS;EAqrCT,kBAAA;AA/JN;AAkKI;;EACE,OAAA;EACA,YAAA;AA/JN;AAkKI;;EACE,kBAAA;EACA,iBAAA;EACA,gBAAA;EACA,cA9rCM;AA+hCZ;AAkKI;;EACE,SAAA;EACA,cAlsCO;EAmsCP,iBAAA;EACA,gBAAA;EACA,kBAAA;AA/JN;;AAoKA;EACE,aAAA;EACA,mBAAA;EACA,8BAAA;EACA,SAAA;EACA,eAAA;EACA,qBAAA;EACA,sBAAA;EACA,mBAAA;EACA,mBAAA;EACA,0CAAA;EACA,6CAAA;AAjKF;AAmKE;EACE,kBAAA;EACA,yBAAA;EACA,sBAAA;EACA,cA3tCS;EA4tCT,gBAAA;AAjKJ;AAoKE;EACE,iBAAA;EACA,gBAAA;EACA,cAnuCQ;AAikCZ;AAqKE;EACE,kBAAA;EACA,gBAAA;EACA,cAxuCS;EAyuCT,oBAAA;AAnKJ;;AAuKA;EACE,aAAA;EACA,0BAAA;EACA,YAAA;AApKF;AAsKE;EALF;IAMI,qCAAA;EAnKF;AACF;;AAsKA;EACE,kBAAA;EACA,6BAAA;EACA,mBAAA;EACA,mBAAA;EACA,yBAAA;EACA,aAAA;EACA,sBAAA;EACA,YAAA;EACA,6CAAA;EACA,6EAAA;EACA,gBAAA;AAnKF;AAqKE;EACE,2BAAA;EACA,gDAAA;EACA,sCAAA;AAnKJ;AAsKE;EACE,qBA/wCW;EAgxCX,gDAAA;AApKJ;AAuKE;EACE,kBAAA;EACA,MAAA;EACA,QAAA;EACA,wBAAA;EACA,iCAAA;EACA,mBAzxCW;EA0xCX,cAAA;EACA,kBAAA;EACA,gBAAA;EACA,sBAAA;EACA,yBAAA;EACA,gBAAA;AArKJ;AAwKE;EACE,cAAA;EACA,eAAA;EACA,sBAAA;EACA,oBAAA;EACA,mBAAA;EACA,uBAAA;EACA,mCAAA;EACA,cA1yCW;AAooCf;AAwKI;EACE,kBAAA;EACA,cAAA;AAtKN;AA0KE;EACE,aAAA;EACA,qBAAA;EACA,8BAAA;EACA,WAAA;AAxKJ;AA2KE;EACE,SAAA;EACA,kBAAA;EACA,gBAAA;EACA,cA1zCQ;AAipCZ;AA4KE;EACE,kBAAA;EACA,gBAAA;EACA,cAn0CW;EAo0CX,mBAAA;EACA,mCAAA;EACA,uBAAA;EACA,oBAAA;AA1KJ;AA6KE;EACE,SAAA;EACA,mBAAA;EACA,cAz0CS;EA00CT,iBAAA;EACA,OAAA;AA3KJ;AA8KE;EACE,aAAA;EACA,qBAAA;EACA,WAAA;EACA,oBAAA;EACA,6BAAA;AA5KJ;AA8KI;EACE,kBAAA;EACA,gBAAA;EACA,cAz1CM;EA01CN,uBAAA;AA5KN;AA+KI;EACE,iBAAA;EACA,yBAAA;EACA,sBAAA;EACA,cAh2CO;EAi2CP,gBAAA;AA7KN;AAiLE;EACE,mBAAA;EACA,WAAA;EACA,gBAAA;EACA,gBAAA;EACA,mBAAA;EACA,sBAAA;EACA,oCAAA;EACA,6BAAA;EACA,yBAAA;EACA,eAAA;EACA,oBAAA;AA/KJ;AAiLI;EACE,8CAAA;EACA,gCAAA;EACA,yBAAA;AA/KN;;AAoLA;EACE,mBAAA;EACA,iBAAA;EACA,cA73CW;EA83CX,kBAAA;EACA,iBAAA;AAjLF;AAmLE;EACE,YAAA;EACA,gBAAA;EACA,UAAA;EACA,cAz4CW;EA04CX,gBAAA;EACA,eAAA;EACA,0BAAA;EACA,0BAAA;AAjLJ;AAmLI;EACE,cAAA;AAjLN;;AAuLA;EACE,mBAAA;AApLF;AAsLE;EACE,aAAA;EACA,mBAAA;EACA,iBAAA;EACA,mBAAA;EACA,WAAA;EACA,mBAAA;AApLJ;AAsLI;EACE,cAAA;EACA,oBAAA;EACA,mBAAA;EACA,uBAAA;EACA,cAAA;EACA,cAv6CS;EAw6CT,kBAAA;EACA,cAAA;EACA,eAAA;AApLN;AAuLI;EACE,cAAA;EACA,YAAA;EACA,WAAA;EACA,6BAAA;EACA,2BAAA;EACA,+BAAA;EACA,oBAAA;EACA,gBAAA;EACA,cAn7CM;AA8vCZ;;AA0LA;EACE,aAAA;EACA,0BAAA;EACA,WAAA;AAvLF;AAyLE;EALF;IAMI,qCAAA;EAtLF;AACF;;AAyLA;EACE,eAAA;EACA,sBAAA;EACA,uBAAA;EACA,yBAAA;EACA,aAAA;EACA,sBAAA;EACA,YAAA;EACA,yCAAA;EACA,2BAAA;AAtLF;AAwLE;EACE,6CAAA;AAtLJ;AAyLE;EACE,gBAAA;EACA,qBAAA;EACA,cAp9CQ;EAq9CR,eAAA;AAvLJ;AA0LE;EACE,mBAAA;EACA,cAz9CS;EA09CT,qBAAA;EACA,YAAA;EACA,gBAAA;AAxLJ;AA2LE;EACE,aAAA;EACA,mBAAA;EACA,8BAAA;EACA,iBAAA;EACA,6BAAA;AAzLJ;AA2LI;EACE,mBAAA;EACA,gBAAA;EACA,cA1+CM;AAizCZ;AA4LI;EACE,kBAAA;EACA,cA9+CO;EA++CP,yBAAA;AA1LN;;AAgMA;EACE,aAAA;EACA,uBAAA;EACA,mBAAA;EACA,gBAAA;AA7LF;;AAgMA;EACE,WAAA;EACA,YAAA;AA7LF;;AAiMA;EACE;IACE,uBAAA;EA9LF;EAgME;IACE,eAAA;EA9LJ;EAkMA;;IAEE,eAAA;EAhMF;AACF;AAoMA;EACE,aAAA;EACA,mBAAA;EACA,SAAA;EACA,iBAAA;EACA,qBAAA;EACA,qBAAA;EACA,mBAAA;EACA,0CAAA;EACA,6FAAA;AAlMF;AAoME;EACE,cAAA;EACA,kBAAA;AAlMJ;AAqME;EACE,aAAA;EACA,sBAAA;EACA,WAAA;EACA,OAAA;EACA,kBAAA;EACA,cAziDQ;AAs2CZ;AAsME;EACE,WAAA;EACA,uBAAA;EACA,YAAA;EACA,sBAAA;EACA,yBAjjDQ;EAkjDR,WAAA;EACA,gBAAA;EACA,eAAA;EACA,mBAAA;AApMJ;AAsMI;EACE,YAAA;AApMN;AAwME;EAzCF;IA0CI,sBAAA;IACA,uBAAA;EArMF;AACF;;AAyMA;EACE,aAAA;EACA,mBAAA;EACA,eAAA;EACA,mBAAA;EACA,kBAAA;EACA,iBAAA;EACA,gBAAA;EACA,cA1kDW;AAo4Cb;AAwME;EACE,uBAAA;EACA,oBAAA;EACA,mBAAA;EACA,cAAA;EACA,iBAAA;EACA,gBAAA;EACA,yBAAA;EACA,sBAAA;EACA,mBAAA;AAtMJ;;AA0MA;EACE,cAAA;EACA,WAAA;EACA,kBAAA;EACA,UAAA;EACA,YAAA;EACA,gBAAA;EACA,cAhmDW;EAimDX,iBAAA;EACA,gBAAA;EACA,0BAAA;EACA,eAAA;AAvMF;AAyME;EACE,cAxmDQ;AAi6CZ;AA0ME;EACE,YAAA;EACA,eAAA;AAxMJ","sourcesContent":["// Color Variables\n$primary-color: #5ea1d8;\n$accent-color: #e83e8c;\n$background-light: #f8fafc;\n$background-dark: #0f172a;\n$text-dark: #0f172a;\n$text-light: #64748b;\n$border-color: #e2e8f0;\n$border-dark: #1e293b;\n\n.pricing-page {\n  min-height: 100vh;\n  background-color: $background-light;\n  // padding-top: calc(56px + 8px);\n  padding-bottom: 3rem;\n}\n\n/* Dark mode */\n:host-context(body.theme-dark) {\n  .pricing-page {\n    background: #0a0c10 !important;\n    color: #e5e7eb !important;\n  }\n\n  .pricing-header .pricing-title,\n  .section-title,\n  .plan-name,\n  .plan-label,\n  .price-amount,\n  .price-text {\n    color: #f8fafc !important;\n  }\n\n  .pricing-header .pricing-subtitle,\n  .section-subtitle,\n  .plan-description,\n  .price-period,\n  .billing-note,\n  .feature-item span {\n    color: #cbd5e1 !important;\n  }\n\n  .billing-label {\n    color: #94a3b8 !important;\n  }\n\n  .billing-label.active {\n    color: #f8fafc !important;\n  }\n\n  .billing-toggle {\n    background-color: #334155 !important;\n  }\n\n  .billing-toggle-container .discount-badge {\n    background-color: #166534 !important;\n    color: #dcfce7 !important;\n    border: 1px solid rgba(134, 239, 172, 0.35);\n  }\n\n  .plan-card,\n  .business-plan-card,\n  .add-on-card,\n  .comparison-table,\n  .faq-item,\n  .free-tier-card {\n    background: #111827 !important;\n    border-color: rgba(148, 163, 184, 0.25) !important;\n    box-shadow: none !important;\n  }\n\n  .free-tier-icon {\n    background: rgba(94, 161, 216, 0.18) !important;\n    color: #93c5fd !important;\n  }\n\n  .free-tier-titles .plan-tier-tag {\n    color: #6ee7b7 !important;\n    background: rgba(6, 95, 70, 0.45) !important;\n  }\n\n  .free-tier-col--cta,\n  .free-tier-col--features {\n    @media (min-width: 900px) {\n      border-left-color: rgba(148, 163, 184, 0.25) !important;\n    }\n  }\n\n  .free-tier-section .section-kicker {\n    color: #93c5fd !important;\n  }\n\n  .plan-card.featured {\n    border-color: #5ea1d8 !important;\n  }\n\n  .plan-button.outline,\n  .cta-button.secondary {\n    background: transparent !important;\n    border-color: #5ea1d8 !important;\n    color: #93c5fd !important;\n  }\n\n  .plan-button.outline:hover,\n  .cta-button.secondary:hover {\n    background: rgba(94, 161, 216, 0.16) !important;\n  }\n\n  /* Catch any remaining copy that may inherit light-mode colors */\n  .pricing-page p,\n  .pricing-page li,\n  .pricing-page td,\n  .pricing-page th,\n  .pricing-page label {\n    color: #cbd5e1 !important;\n  }\n\n  .pricing-page span:not(.material-icons) {\n    color: #cbd5e1 !important;\n  }\n\n  .add-ons-section .section-title,\n  .add-ons-section .add-on-title,\n  .add-ons-section .price-text {\n    color: #f8fafc !important;\n  }\n\n  .add-ons-section .add-on-description,\n  .add-ons-section .price-unit {\n    color: #cbd5e1 !important;\n  }\n\n  .add-ons-section .add-on-price {\n    border-top-color: rgba(148, 163, 184, 0.25) !important;\n  }\n\n  /* AI Coins section – dark mode */\n  .ai-coins-section,\n  .guide-topups-section {\n    background: linear-gradient(\n      180deg,\n      rgba(232, 62, 140, 0.1) 0%,\n      rgba(17, 24, 39, 0.55) 100%\n    ) !important;\n    border-color: rgba(232, 62, 140, 0.22) !important;\n  }\n\n  .ai-coins-section .section-title,\n  .ai-coins-section .coin-pack-name,\n  .ai-coins-section .coin-pack-price .price-amount,\n  .ai-coins-section .balance-value {\n    color: #f8fafc !important;\n  }\n\n  .ai-coins-section .section-subtitle,\n  .ai-coins-section .coin-pack-description,\n  .ai-coins-section .coin-pack-price .price-unit,\n  .ai-coins-section .balance-label,\n  .ai-coins-section .balance-detail,\n  .ai-coins-section .coin-footnote {\n    color: #94a3b8 !important;\n  }\n\n  .ai-coins-section .section-icon,\n  .ai-coins-section .coin-pack-amount,\n  .ai-coins-section .inline-link {\n    color: #f472b6 !important;\n  }\n\n  .coin-balance-banner {\n    background: linear-gradient(\n      135deg,\n      rgba(94, 161, 216, 0.16),\n      rgba(232, 62, 140, 0.12)\n    ) !important;\n    border-color: rgba(148, 163, 184, 0.28) !important;\n  }\n\n  .coin-pack-card {\n    background: #111827 !important;\n    border-color: rgba(148, 163, 184, 0.28) !important;\n    box-shadow: none !important;\n\n    &:hover {\n      border-color: rgba(232, 62, 140, 0.45) !important;\n      box-shadow: 0 8px 24px rgba(0, 0, 0, 0.35) !important;\n    }\n\n    &.featured {\n      border-color: #e83e8c !important;\n      background: linear-gradient(\n        180deg,\n        rgba(232, 62, 140, 0.12) 0%,\n        #111827 40%\n      ) !important;\n    }\n  }\n\n  .coin-pack-icon {\n    background: rgba(232, 62, 140, 0.18) !important;\n    color: #f472b6 !important;\n  }\n\n  .coin-pack-badge {\n    background: #e83e8c !important;\n    color: #ffffff !important;\n  }\n\n  .plan-tier-tag {\n    background: #1f2937 !important;\n    color: #cbd5e1 !important;\n\n    &.creator {\n      background: rgba(94, 161, 216, 0.2) !important;\n      color: #93c5fd !important;\n    }\n  }\n\n  .plan-icon,\n  .feature-item .material-icons,\n  .feature-item .check-icon {\n    color: #93c5fd !important;\n  }\n\n  .feature-item.disabled,\n  .feature-item.disabled .material-icons {\n    color: #64748b !important;\n  }\n\n  .audience-label,\n  .audience-text,\n  .plan-audience p {\n    color: #94a3b8 !important;\n  }\n\n  .price-old {\n    color: #64748b !important;\n  }\n\n  .price-new {\n    color: #f8fafc !important;\n  }\n\n  .faq-question,\n  .faq-item h3,\n  .faq-item .question,\n  .comparison-table th,\n  .comparison-table td {\n    color: #e2e8f0 !important;\n  }\n\n  .cta-section,\n  .cta-card {\n    background: #111827 !important;\n    color: #e2e8f0 !important;\n  }\n\n  .plan-button.current-plan,\n  .plan-button.dark {\n    background: #1f2937 !important;\n    color: #e2e8f0 !important;\n    border-color: rgba(148, 163, 184, 0.35) !important;\n  }\n}\n\n// Footer — light by default (matches FAQ / How it works); dark only in theme-dark\n.footer {\n  background: #f1f5f9;\n  color: #475569;\n  padding: 14px 0;\n  border-top: 1px solid #e2e8f0;\n\n  .copy-rights {\n    max-width: 1400px;\n    margin: 0 auto;\n    padding: 0 24px;\n    width: 100%;\n\n    .row {\n      display: flex;\n      align-items: center;\n      margin: 0;\n      width: 100%;\n\n      @media (max-width: 768px) {\n        flex-direction: column;\n        align-items: flex-start;\n        gap: 16px;\n      }\n    }\n\n    .col-md-5,\n    .col-md-7,\n    .col-12 {\n      padding: 0;\n      display: flex;\n      align-items: center;\n\n      @media (max-width: 768px) {\n        width: 100%;\n        justify-content: flex-start;\n      }\n    }\n\n    .col-md-5 {\n      @media (min-width: 769px) {\n        justify-content: flex-start;\n      }\n    }\n\n    .col-md-7 {\n      @media (min-width: 769px) {\n        justify-content: flex-end;\n      }\n    }\n  }\n\n  .cpyrgt {\n    color: #64748b !important;\n    list-style: none;\n    padding: 0;\n    margin: 0;\n    display: flex;\n    align-items: center;\n    font-size: 14px;\n    line-height: 1.5;\n    width: 100%;\n\n    @media (max-width: 768px) {\n      flex-wrap: wrap;\n    }\n\n    li {\n      color: #64748b !important;\n      margin: 0;\n      padding: 0;\n      display: flex;\n      align-items: center;\n      flex-wrap: wrap;\n\n      a {\n        color: #64748b !important;\n        text-decoration: none;\n        margin-left: 4px;\n\n        &:hover {\n          color: #5ea1d8 !important;\n          text-decoration: underline;\n        }\n      }\n    }\n  }\n\n  .f-menu-right {\n    display: flex;\n    list-style: none;\n    padding: 0;\n    margin: 0;\n    align-items: center;\n    justify-content: flex-end;\n    flex-wrap: wrap;\n    gap: 0;\n    width: 100%;\n\n    @media (max-width: 768px) {\n      justify-content: flex-start;\n      flex-direction: column;\n      align-items: flex-start;\n      gap: 8px;\n    }\n\n    li {\n      margin: 0;\n      padding: 0;\n\n      @media (min-width: 769px) {\n        &:not(:last-child)::after {\n          content: \"|\";\n          margin: 0 12px;\n          color: #94a3b8;\n        }\n      }\n\n      a {\n        color: #64748b !important;\n        text-decoration: none;\n        font-size: 14px;\n        transition: color 0.2s ease;\n\n        &:hover {\n          color: #5ea1d8 !important;\n          text-decoration: underline;\n        }\n      }\n    }\n  }\n}\n\n:host-context(body.theme-dark) {\n  .footer {\n    background: #000000 !important;\n    color: #ffffff !important;\n    border-top: 1px solid rgba(255, 255, 255, 0.05) !important;\n\n    .cpyrgt,\n    .cpyrgt li,\n    .cpyrgt li a,\n    .f-menu-right li a {\n      color: #64748b !important;\n    }\n\n    .cpyrgt li a:hover,\n    .f-menu-right li a:hover {\n      color: #5ea1d8 !important;\n    }\n\n    .f-menu-right li:not(:last-child)::after {\n      color: #64748b;\n    }\n  }\n}\n\n// Shared content column — keeps hero + section headers on the same axis\n$pricing-content-max: 1280px;\n$pricing-gutter: 1rem;\n$pricing-copy-max: 40rem;\n\n// Header Section\n.pricing-header {\n  text-align: center;\n  box-sizing: border-box;\n  width: 100%;\n  max-width: $pricing-content-max;\n  margin: 0 auto;\n  padding: 1.5rem $pricing-gutter 0.25rem;\n  display: flex;\n  flex-direction: column;\n  align-items: center;\n  justify-content: center;\n\n  .pricing-title {\n    font-size: 2.5rem;\n    font-weight: 800;\n    margin: 0 0 0.75rem;\n    line-height: 1.2;\n    color: $text-dark;\n    max-width: $pricing-copy-max;\n    width: 100%;\n\n    @media (min-width: 768px) {\n      font-size: 3.25rem;\n    }\n\n    .text-primary {\n      // Ensure \\\"Path\\\" uses the Flowchest blue brand color\n      color: $primary-color !important;\n    }\n  }\n\n  .pricing-subtitle {\n    max-width: $pricing-copy-max;\n    width: 100%;\n    margin: 0 auto 1.75rem;\n    font-size: 1.125rem;\n    color: $text-light;\n    line-height: 1.6;\n  }\n}\n\n.billing-toggle-container {\n  display: flex;\n  align-items: center;\n  justify-content: center;\n  gap: 1rem;\n\n  .billing-label {\n    font-size: 0.875rem;\n    font-weight: 500;\n    color: $text-light;\n    transition: color 0.2s;\n\n    &.active {\n      color: $text-dark;\n      font-weight: 600;\n    }\n\n    .discount-badge {\n      display: inline-block;\n      padding: 0.125rem 0.5rem;\n      background-color: #dcfce7;\n      color: #16a34a;\n      font-size: 0.75rem;\n      font-weight: 700;\n      border-radius: 9999px;\n      margin-left: 0.5rem;\n    }\n  }\n\n  .billing-toggle {\n    position: relative;\n    width: 3.5rem;\n    height: 1.75rem;\n    background-color: #cbd5e1;\n    border: none;\n    border-radius: 9999px;\n    padding: 0.25rem;\n    cursor: pointer;\n    transition: background-color 0.2s;\n    outline: none;\n\n    &:focus {\n      outline: 2px solid $primary-color;\n      outline-offset: 2px;\n    }\n\n    &.active {\n      background-color: $primary-color;\n\n      .toggle-dot {\n        transform: translateX(1.75rem);\n      }\n    }\n\n    .toggle-dot {\n      width: 1.25rem;\n      height: 1.25rem;\n      background-color: white;\n      border-radius: 50%;\n      box-shadow: 0 1px 2px rgba(0, 0, 0, 0.1);\n      transition: transform 0.2s;\n      display: block;\n    }\n  }\n}\n\n.billing-note {\n  font-size: 0.7rem;\n  margin-left: 0.25rem;\n  color: $text-light;\n}\n\n// Main Content\n.pricing-main {\n  box-sizing: border-box;\n  width: 100%;\n  max-width: $pricing-content-max;\n  margin: 0 auto;\n  padding: 0 $pricing-gutter;\n}\n\n// Shared centered section headers (free tier + business + add-ons)\n.pricing-main .section-header {\n  text-align: center;\n  display: flex;\n  flex-direction: column;\n  align-items: center;\n  margin-bottom: 1.75rem;\n\n  .section-kicker {\n    margin: 0 0 0.45rem;\n    font-size: 0.75rem;\n    font-weight: 700;\n    letter-spacing: 0.08em;\n    text-transform: uppercase;\n    color: $primary-color;\n  }\n\n  .section-title {\n    font-size: 1.875rem;\n    font-weight: 700;\n    margin: 0 0 0.5rem;\n    color: $text-dark;\n    max-width: $pricing-copy-max;\n    width: 100%;\n    line-height: 1.25;\n  }\n\n  .section-subtitle {\n    margin: 0 auto;\n    max-width: $pricing-copy-max;\n    width: 100%;\n    color: $text-light;\n    font-size: 1.125rem;\n    line-height: 1.6;\n  }\n}\n\n// Individual Plans Section\n.individual-plans-section {\n  margin-bottom: 5rem;\n}\n\n.individual-plans {\n  display: grid;\n  grid-template-columns: 1fr;\n  gap: 2rem;\n\n  @media (min-width: 768px) {\n    grid-template-columns: repeat(2, 1fr);\n  }\n}\n\n// Free tier — full-width 3-column card aligned with business plans width\n.free-tier-section {\n  margin: 0 0 3.25rem;\n}\n\n.free-tier-card {\n  display: grid;\n  grid-template-columns: 1fr;\n  gap: 1.5rem;\n  align-items: stretch;\n  padding: 1.75rem;\n  border-radius: 1rem;\n  border: 1px solid $border-color;\n  background: #ffffff;\n  box-shadow: 0 1px 2px rgba(15, 23, 42, 0.04);\n\n  @media (min-width: 900px) {\n    grid-template-columns: minmax(0, 1.35fr) minmax(0, 1fr) 200px;\n    gap: 0;\n    padding: 0;\n    min-height: 188px;\n  }\n}\n\n.free-tier-col {\n  min-width: 0;\n\n  @media (min-width: 900px) {\n    padding: 1.75rem 1.5rem;\n    display: flex;\n    flex-direction: column;\n    justify-content: center;\n  }\n}\n\n.free-tier-col--info {\n  @media (min-width: 900px) {\n    padding-left: 2rem;\n    padding-right: 1.75rem;\n  }\n}\n\n.free-tier-col--features {\n  list-style: none;\n  margin: 0;\n  padding: 0;\n  display: flex;\n  flex-direction: column;\n  gap: 0.7rem;\n\n  @media (min-width: 900px) {\n    border-left: 1px solid $border-color;\n    padding-left: 1.75rem;\n    padding-right: 1.5rem;\n  }\n\n  .feature-item {\n    display: flex;\n    align-items: center;\n    gap: 0.45rem;\n    margin: 0;\n    font-size: 0.9rem;\n    color: $text-dark;\n    line-height: 1.35;\n\n    .material-icons,\n    .check-icon {\n      flex-shrink: 0;\n      font-size: 1.1rem !important;\n      color: $primary-color;\n    }\n\n    &.disabled {\n      color: $text-light;\n\n      .material-icons {\n        color: #94a3b8;\n      }\n    }\n  }\n}\n\n.free-tier-col--cta {\n  display: flex;\n  flex-direction: column;\n  align-items: stretch;\n  gap: 0.7rem;\n\n  @media (min-width: 900px) {\n    border-left: 1px solid $border-color;\n    padding: 1.75rem 1.75rem 1.75rem 1.5rem;\n    align-items: center;\n    justify-content: center;\n    text-align: center;\n  }\n\n  .price-text {\n    font-size: 1.15rem;\n    font-weight: 700;\n    color: $text-dark;\n    line-height: 1.2;\n    text-align: center;\n  }\n\n  .plan-button {\n    width: 100%;\n    max-width: 100%;\n    padding: 0.8rem 1.1rem;\n    font-weight: 700;\n    border-radius: 0.75rem;\n    cursor: pointer;\n    transition: all 0.2s;\n    font-size: 0.875rem;\n    white-space: nowrap;\n\n    &.outline {\n      border: 2px solid $border-color;\n      background-color: transparent;\n      color: $text-dark;\n\n      &:hover {\n        border-color: $primary-color;\n        color: $primary-color;\n        background: rgba(94, 161, 216, 0.06);\n      }\n    }\n  }\n}\n\n.free-tier-identity {\n  display: flex;\n  align-items: flex-start;\n  gap: 0.85rem;\n  margin-bottom: 0.85rem;\n}\n\n.free-tier-icon {\n  flex-shrink: 0;\n  width: 2.75rem;\n  height: 2.75rem;\n  display: inline-flex;\n  align-items: center;\n  justify-content: center;\n  border-radius: 0.85rem;\n  background: rgba(94, 161, 216, 0.12);\n  color: $primary-color;\n  font-size: 1.4rem !important;\n  line-height: 1;\n}\n\n.free-tier-titles {\n  display: flex;\n  flex-direction: column;\n  align-items: flex-start;\n  gap: 0.4rem;\n  min-width: 0;\n  padding-top: 0.1rem;\n\n  .plan-name {\n    margin: 0 !important;\n    font-size: 1.25rem !important;\n    font-weight: 700 !important;\n    color: $text-dark;\n    line-height: 1.25;\n  }\n\n  .plan-tier-tag {\n    display: inline-block;\n    width: fit-content;\n    font-size: 0.6875rem;\n    font-weight: 700;\n    text-transform: uppercase;\n    letter-spacing: 0.06em;\n    color: #047857;\n    background: #ecfdf5;\n    padding: 0.2rem 0.625rem;\n    border-radius: 999px;\n  }\n}\n\n.free-tier-col--info .plan-description {\n  margin: 0;\n  color: $text-light;\n  font-size: 0.95rem;\n  line-height: 1.55;\n  max-width: 28rem;\n}\n\n.plan-card {\n  padding: 2rem;\n  border-radius: 1rem;\n  border: 1px solid $border-color;\n  background-color: white;\n  transition: all 0.3s;\n  display: flex;\n  flex-direction: column;\n\n  &:hover {\n    box-shadow: 0 20px 25px -5px rgba(0, 0, 0, 0.1);\n  }\n\n  &.standard-plan {\n    border: 1px solid $border-color;\n  }\n\n  &.creator-plan {\n    border: 2px solid $primary-color;\n    box-shadow: 0 25px 50px -12px rgba(94, 161, 216, 0.1);\n    position: relative;\n  }\n\n  .plan-header {\n    display: flex;\n    flex-direction: row;\n    flex-wrap: nowrap;\n    align-items: flex-start;\n    gap: 0.75rem;\n    margin-bottom: 1rem;\n\n    .plan-icon {\n      flex-shrink: 0;\n      font-family: \"Material Icons\" !important;\n      font-size: 1.5rem;\n      line-height: 1;\n      color: $text-light;\n      margin-top: 0.125rem;\n    }\n\n    .plan-header-text {\n      flex: 1;\n      min-width: 0;\n      display: flex;\n      flex-direction: column;\n      gap: 0.35rem;\n    }\n\n    .plan-name {\n      font-size: 1.25rem !important;\n      font-weight: 700 !important;\n      font-family: inherit !important;\n      margin: 0 !important;\n      line-height: 1.3;\n      color: $text-dark;\n    }\n  }\n\n  .plan-tier-tag {\n    display: inline-block;\n    width: fit-content;\n    font-size: 0.6875rem;\n    font-weight: 700;\n    text-transform: uppercase;\n    letter-spacing: 0.06em;\n    color: #64748b;\n    background: #f1f5f9;\n    padding: 0.2rem 0.625rem;\n    border-radius: 999px;\n\n    &.creator {\n      color: #4a92c8;\n      background: rgba(94, 161, 216, 0.12);\n    }\n  }\n\n  .plan-description {\n    color: $text-light;\n    margin-bottom: 1.5rem;\n    min-height: 60px;\n    line-height: 1.6;\n  }\n\n  .plan-price {\n    margin-bottom: 2rem;\n\n    .price-text {\n      font-size: 1.875rem;\n      font-weight: 700;\n      font-style: italic;\n      color: $text-dark;\n    }\n  }\n\n  .plan-features {\n    list-style: none;\n    padding: 0;\n    margin: 0 0 2rem;\n    flex-grow: 1;\n\n    .feature-item {\n      display: flex;\n      align-items: flex-start;\n      gap: 0.75rem;\n      font-size: 0.875rem;\n      margin-bottom: 1rem;\n\n      .material-icons {\n        flex-shrink: 0;\n        font-family: \"Material Icons\" !important;\n        font-size: 1.125rem;\n        line-height: 1.4;\n        color: $primary-color;\n      }\n\n      &.disabled {\n        color: $text-light;\n\n        .material-icons {\n          color: $text-light;\n        }\n      }\n\n      .check-icon {\n        color: $primary-color;\n      }\n    }\n  }\n\n  .plan-button {\n    width: 100%;\n    padding: 0.75rem;\n    font-weight: 700;\n    border-radius: 0.75rem;\n    border: none;\n    cursor: pointer;\n    transition: all 0.2s;\n    font-size: 0.875rem;\n\n    &.outline {\n      border: 2px solid $border-color;\n      background-color: transparent;\n      color: $text-dark;\n\n      &:hover {\n        border-color: $primary-color;\n        color: $primary-color;\n      }\n    }\n\n    &.primary {\n      background-color: $primary-color;\n      color: white;\n      box-shadow: 0 10px 15px -3px rgba(94, 161, 216, 0.25);\n\n      &:hover {\n        transform: scale(1.02);\n        box-shadow: 0 20px 25px -5px rgba(94, 161, 216, 0.3);\n      }\n\n      &:active {\n        transform: scale(0.98);\n      }\n    }\n\n    &.current-plan {\n      background-color: #ecfdf5;\n      color: #047857;\n      border: 1px solid #a7f3d0;\n      cursor: default;\n      box-shadow: none;\n\n      &:disabled {\n        opacity: 1;\n      }\n    }\n  }\n}\n\n// Business Solutions Section\n.business-solutions {\n  margin-bottom: 5rem;\n\n  .section-header {\n    margin-bottom: 3rem;\n\n    .business-billing-toggle {\n      margin-top: 1.25rem;\n    }\n  }\n}\n\n.business-plans {\n  display: grid;\n  grid-template-columns: 1fr;\n  gap: 2rem;\n\n  @media (min-width: 768px) {\n    grid-template-columns: repeat(3, 1fr);\n  }\n}\n\n.business-plan-card {\n  padding: 2rem;\n  border-radius: 1rem;\n  background-color: white;\n  border: 1px solid $border-color;\n  display: flex;\n  flex-direction: column;\n  position: relative;\n  transition: all 0.3s;\n\n  &:hover {\n    box-shadow: 0 4px 6px -1px rgba(0, 0, 0, 0.1);\n  }\n\n  &.growth-plan {\n    border: 2px solid $accent-color;\n    box-shadow: 0 25px 50px -12px rgba(232, 62, 140, 0.1);\n    transform: translateY(-1rem);\n\n    @media (max-width: 767px) {\n      transform: none;\n    }\n\n    .popular-badge {\n      position: absolute;\n      top: 0;\n      right: 0;\n      background-color: $accent-color;\n      color: white;\n      padding: 0.25rem 1rem;\n      font-size: 0.75rem;\n      font-weight: 700;\n      border-bottom-left-radius: 0.75rem;\n      border-top-right-radius: 0.75rem;\n      letter-spacing: 0.05em;\n      text-transform: uppercase;\n      overflow: hidden;\n      pointer-events: none;\n      z-index: 1;\n    }\n  }\n\n  .plan-header {\n    margin-bottom: 1.5rem;\n\n    .plan-label {\n      font-weight: 700;\n      color: $text-light;\n      text-transform: uppercase;\n      letter-spacing: 0.1em;\n      font-size: 0.75rem;\n      margin-bottom: 0.5rem;\n    }\n\n    .plan-price {\n      display: flex;\n      align-items: baseline;\n      gap: 0.25rem;\n      flex-wrap: wrap;\n\n      .price-amount {\n        font-size: 2.25rem;\n        font-weight: 800;\n        color: $text-dark;\n      }\n\n      .price-period {\n        color: $text-light;\n        font-size: 1rem;\n      }\n\n      .price-old {\n        font-size: 1.125rem;\n        font-weight: 600;\n        color: $text-light;\n        text-decoration: line-through;\n        margin-right: 0.5rem;\n      }\n\n      .price-new {\n        color: $accent-color;\n      }\n    }\n  }\n\n  .plan-audience {\n    padding: 0.75rem 0;\n    border-top: 1px solid #f1f5f9;\n    border-bottom: 1px solid #f1f5f9;\n    margin-bottom: 1.5rem;\n\n    .audience-label {\n      font-size: 0.75rem;\n      font-weight: 600;\n      color: $text-light;\n      text-transform: uppercase;\n      letter-spacing: 0.05em;\n      margin-bottom: 0.25rem;\n    }\n\n    .audience-text {\n      font-size: 0.875rem;\n      color: $text-dark;\n      margin: 0;\n    }\n  }\n\n  .plan-features {\n    list-style: none;\n    padding: 0;\n    margin: 0 0 2.5rem;\n    flex-grow: 1;\n\n    .feature-item {\n      display: flex;\n      align-items: flex-start;\n      gap: 0.75rem;\n      font-size: 0.875rem;\n      margin-bottom: 1rem;\n\n      .material-icons {\n        font-size: 0.875rem;\n        margin-top: 0.125rem;\n        color: $primary-color;\n      }\n\n      &.info {\n        color: $text-light;\n\n        .material-icons {\n          color: $text-light;\n        }\n      }\n\n      .font-medium {\n        font-weight: 500;\n      }\n    }\n  }\n\n  .plan-button {\n    width: 100%;\n    padding: 0.75rem;\n    font-weight: 700;\n    border-radius: 0.75rem;\n    border: none;\n    cursor: pointer;\n    transition: all 0.2s;\n    font-size: 0.875rem;\n    position: relative;\n    z-index: 2;\n    pointer-events: auto;\n\n    &.dark {\n      background-color: $text-dark;\n      color: white;\n\n      &:hover {\n        opacity: 0.9;\n      }\n    }\n\n    &.accent {\n      background-color: $accent-color;\n      color: white;\n      box-shadow: 0 10px 15px -3px rgba(232, 62, 140, 0.25);\n\n      &:hover {\n        box-shadow: 0 20px 25px -5px rgba(232, 62, 140, 0.3);\n      }\n    }\n\n    &.outline {\n      border: 2px solid $border-color;\n      background-color: transparent;\n      color: $text-dark;\n\n      &:hover {\n        border-color: $text-dark;\n        color: $text-dark;\n      }\n    }\n  }\n}\n\n// AI Coin Top-ups Section\n.ai-coins-section,\n.guide-topups-section {\n  margin: 0 0 5rem;\n  padding: 2rem 1.5rem;\n  border-radius: 1.25rem;\n  background: linear-gradient(\n    180deg,\n    rgba(232, 62, 140, 0.06) 0%,\n    rgba(94, 161, 216, 0.04) 100%\n  );\n  border: 1px solid rgba(232, 62, 140, 0.12);\n  scroll-margin-top: 5rem;\n\n  .section-header {\n    display: flex;\n    align-items: flex-start;\n    gap: 0.85rem;\n    margin-bottom: 1.75rem;\n\n    .section-icon {\n      flex-shrink: 0;\n      width: 2.5rem;\n      height: 2.5rem;\n      border-radius: 0.75rem;\n      display: inline-flex;\n      align-items: center;\n      justify-content: center;\n      background: rgba(232, 62, 140, 0.12);\n      color: $accent-color;\n      font-size: 1.35rem;\n    }\n\n    .section-header-text {\n      flex: 1;\n      min-width: 0;\n    }\n\n    .section-title {\n      margin: 0 0 0.4rem;\n      font-size: 1.5rem;\n      font-weight: 700;\n      color: $text-dark;\n    }\n\n    .section-subtitle {\n      margin: 0;\n      color: $text-light;\n      line-height: 1.55;\n      max-width: 720px;\n      font-size: 0.95rem;\n    }\n  }\n}\n\n.coin-balance-banner {\n  display: flex;\n  align-items: center;\n  justify-content: space-between;\n  gap: 1rem;\n  flex-wrap: wrap;\n  padding: 1rem 1.35rem;\n  margin-bottom: 1.75rem;\n  border-radius: 14px;\n  background: #ffffff;\n  border: 1px solid rgba(94, 161, 216, 0.22);\n  box-shadow: 0 2px 10px rgba(15, 23, 42, 0.04);\n\n  .balance-label {\n    font-size: 0.75rem;\n    text-transform: uppercase;\n    letter-spacing: 0.06em;\n    color: $text-light;\n    font-weight: 700;\n  }\n\n  .balance-value {\n    font-size: 1.2rem;\n    font-weight: 700;\n    color: $text-dark;\n  }\n\n  .balance-detail {\n    font-size: 0.85rem;\n    font-weight: 500;\n    color: $text-light;\n    margin-left: 0.35rem;\n  }\n}\n\n.coin-packs-grid {\n  display: grid;\n  grid-template-columns: 1fr;\n  gap: 1.25rem;\n\n  @media (min-width: 768px) {\n    grid-template-columns: repeat(3, 1fr);\n  }\n}\n\n.coin-pack-card {\n  position: relative;\n  padding: 1.6rem 1.4rem 1.4rem;\n  border-radius: 1rem;\n  background: #ffffff;\n  border: 1px solid $border-color;\n  display: flex;\n  flex-direction: column;\n  gap: 0.85rem;\n  box-shadow: 0 4px 14px rgba(15, 23, 42, 0.05);\n  transition: transform 0.2s ease, box-shadow 0.2s ease, border-color 0.2s ease;\n  overflow: hidden;\n\n  &:hover {\n    transform: translateY(-3px);\n    box-shadow: 0 12px 28px rgba(232, 62, 140, 0.12);\n    border-color: rgba(232, 62, 140, 0.35);\n  }\n\n  &.featured {\n    border-color: $accent-color;\n    box-shadow: 0 10px 28px rgba(232, 62, 140, 0.14);\n  }\n\n  .coin-pack-badge {\n    position: absolute;\n    top: 0;\n    right: 0;\n    padding: 0.35rem 0.75rem;\n    border-radius: 0 0.9rem 0 0.75rem;\n    background: $accent-color;\n    color: #ffffff;\n    font-size: 0.65rem;\n    font-weight: 700;\n    letter-spacing: 0.04em;\n    text-transform: uppercase;\n    line-height: 1.2;\n  }\n\n  .coin-pack-icon {\n    width: 2.75rem;\n    height: 2.75rem;\n    border-radius: 0.85rem;\n    display: inline-flex;\n    align-items: center;\n    justify-content: center;\n    background: rgba(232, 62, 140, 0.1);\n    color: $accent-color;\n\n    .material-icons {\n      font-size: 1.35rem;\n      color: inherit;\n    }\n  }\n\n  .coin-pack-header {\n    display: flex;\n    align-items: baseline;\n    justify-content: space-between;\n    gap: 0.5rem;\n  }\n\n  .coin-pack-name {\n    margin: 0;\n    font-size: 1.05rem;\n    font-weight: 700;\n    color: $text-dark;\n  }\n\n  .coin-pack-amount {\n    font-size: 0.85rem;\n    font-weight: 700;\n    color: $accent-color;\n    white-space: nowrap;\n    background: rgba(232, 62, 140, 0.1);\n    padding: 0.2rem 0.55rem;\n    border-radius: 999px;\n  }\n\n  .coin-pack-description {\n    margin: 0;\n    font-size: 0.875rem;\n    color: $text-light;\n    line-height: 1.55;\n    flex: 1;\n  }\n\n  .coin-pack-price {\n    display: flex;\n    align-items: baseline;\n    gap: 0.4rem;\n    padding-top: 0.35rem;\n    border-top: 1px solid #f1f5f9;\n\n    .price-amount {\n      font-size: 1.65rem;\n      font-weight: 800;\n      color: $text-dark;\n      letter-spacing: -0.02em;\n    }\n\n    .price-unit {\n      font-size: 0.7rem;\n      text-transform: uppercase;\n      letter-spacing: 0.05em;\n      color: $text-light;\n      font-weight: 700;\n    }\n  }\n\n  .coin-buy-btn {\n    margin-top: 0.25rem;\n    width: 100%;\n    padding: 0.75rem;\n    font-weight: 700;\n    font-size: 0.875rem;\n    border-radius: 0.75rem;\n    border: 2px solid $accent-color !important;\n    background-color: transparent;\n    color: $accent-color !important;\n    cursor: pointer;\n    transition: all 0.2s;\n\n    &:hover {\n      background: rgba(232, 62, 140, 0.1) !important;\n      border-color: $accent-color !important;\n      color: #c2185b !important;\n    }\n  }\n}\n\n.coin-footnote {\n  margin: 1.75rem 0 0;\n  font-size: 0.9rem;\n  color: $text-light;\n  text-align: center;\n  line-height: 1.55;\n\n  .inline-link {\n    border: none;\n    background: none;\n    padding: 0;\n    color: $accent-color;\n    font-weight: 700;\n    cursor: pointer;\n    text-decoration: underline;\n    text-underline-offset: 2px;\n\n    &:hover {\n      color: #c2185b;\n    }\n  }\n}\n\n// Add-ons Section\n.add-ons-section {\n  margin-bottom: 6rem;\n\n  .section-header {\n    display: flex;\n    flex-direction: row;\n    flex-wrap: nowrap;\n    align-items: center;\n    gap: 0.5rem;\n    margin-bottom: 2rem;\n\n    .section-icon {\n      flex-shrink: 0;\n      display: inline-flex;\n      align-items: center;\n      justify-content: center;\n      line-height: 1;\n      color: $accent-color;\n      font-size: 1.25rem;\n      width: 1.25rem;\n      height: 1.25rem;\n    }\n\n    .section-title {\n      flex: 1 1 auto;\n      min-width: 0;\n      width: auto;\n      font-size: 1.25rem !important;\n      font-weight: 700 !important;\n      font-family: inherit !important;\n      margin: 0 !important;\n      line-height: 1.3;\n      color: $text-dark;\n    }\n  }\n}\n\n.add-ons-grid {\n  display: grid;\n  grid-template-columns: 1fr;\n  gap: 1.5rem;\n\n  @media (min-width: 1024px) {\n    grid-template-columns: repeat(3, 1fr);\n  }\n}\n\n.add-on-card {\n  padding: 1.5rem;\n  border-radius: 0.75rem;\n  background-color: white;\n  border: 1px solid #f1f5f9;\n  display: flex;\n  flex-direction: column;\n  height: 100%;\n  box-shadow: 0 1px 2px rgba(0, 0, 0, 0.05);\n  transition: box-shadow 0.2s;\n\n  &:hover {\n    box-shadow: 0 4px 6px -1px rgba(0, 0, 0, 0.1);\n  }\n\n  .add-on-title {\n    font-weight: 700;\n    margin-bottom: 0.5rem;\n    color: $text-dark;\n    font-size: 1rem;\n  }\n\n  .add-on-description {\n    font-size: 0.875rem;\n    color: $text-light;\n    margin-bottom: 1.5rem;\n    flex-grow: 1;\n    line-height: 1.5;\n  }\n\n  .add-on-price {\n    display: flex;\n    align-items: center;\n    justify-content: space-between;\n    padding-top: 1rem;\n    border-top: 1px solid #f8fafc;\n\n    .price-text {\n      font-size: 0.875rem;\n      font-weight: 600;\n      color: $text-dark;\n    }\n\n    .price-unit {\n      font-size: 0.75rem;\n      color: $text-light;\n      text-transform: uppercase;\n    }\n  }\n}\n\n// Loading Spinner\n.img-div-left {\n  display: flex;\n  justify-content: center;\n  align-items: center;\n  min-height: 50vh;\n}\n\n.spinner-global {\n  width: 50px;\n  height: 50px;\n}\n\n// Responsive adjustments\n@media (max-width: 767px) {\n  .pricing-header {\n    padding: 1rem 1rem 1rem;\n\n    .pricing-title {\n      font-size: 2rem;\n    }\n  }\n\n  .plan-card,\n  .business-plan-card {\n    padding: 1.5rem;\n  }\n}\n\n// Starter free trial\n.trial-banner {\n  display: flex;\n  align-items: center;\n  gap: 1rem;\n  max-width: 1100px;\n  margin: 0 auto 2.5rem;\n  padding: 1rem 1.25rem;\n  border-radius: 1rem;\n  border: 1px solid rgba(94, 161, 216, 0.35);\n  background: linear-gradient(90deg, rgba(94, 161, 216, 0.12) 0%, rgba(22, 101, 52, 0.08) 100%);\n\n  .trial-banner-icon {\n    color: #4a92c8;\n    font-size: 1.75rem;\n  }\n\n  .trial-banner-text {\n    display: flex;\n    flex-direction: column;\n    gap: 0.2rem;\n    flex: 1;\n    font-size: 0.95rem;\n    color: $text-dark;\n  }\n\n  .trial-banner-btn {\n    width: auto;\n    padding: 0.7rem 1.25rem;\n    border: none;\n    border-radius: 0.75rem;\n    background-color: $text-dark;\n    color: #fff;\n    font-weight: 700;\n    cursor: pointer;\n    white-space: nowrap;\n\n    &:disabled {\n      opacity: 0.6;\n    }\n  }\n\n  @media (max-width: 640px) {\n    flex-direction: column;\n    align-items: flex-start;\n  }\n}\n\n// One line under the Starter price so the trial doesn't stretch the card.\n.business-plan-card .plan-trial-line {\n  display: flex;\n  align-items: center;\n  flex-wrap: wrap;\n  gap: 0.25rem 0.5rem;\n  margin: 0.5rem 0 0;\n  font-size: 0.8rem;\n  line-height: 1.3;\n  color: $text-light;\n\n  .plan-trial-pill {\n    padding: 0.15rem 0.5rem;\n    border-radius: 999px;\n    background: #dcfce7;\n    color: #166534;\n    font-size: 0.7rem;\n    font-weight: 700;\n    text-transform: uppercase;\n    letter-spacing: 0.04em;\n    white-space: nowrap;\n  }\n}\n\n.business-plan-card .plan-skip-trial {\n  display: block;\n  width: 100%;\n  margin-top: 0.4rem;\n  padding: 0;\n  border: none;\n  background: none;\n  color: $text-light;\n  font-size: 0.8rem;\n  font-weight: 600;\n  text-decoration: underline;\n  cursor: pointer;\n\n  &:hover {\n    color: $text-dark;\n  }\n\n  &:disabled {\n    opacity: 0.6;\n    cursor: default;\n  }\n}\n"],"sourceRoot":""}]);
// Exports
module.exports = ___CSS_LOADER_EXPORT___.toString();
